import { Fragment, useCallback, useEffect, useState } from 'react';
import { MonChefEquipe } from './MonChefEquipe.jsx';
import { nomDuChantier } from '../../lib/nom-chantier';
import { GuideInstallation } from '../../pwa/GuideInstallation.jsx';
import { estInstallee } from '../../pwa/installation';
import { utiliseManifeste } from '../../pwa/manifeste';
import { ouvrierRetenu } from '../../lib/appareil-ouvrier';
import { useModeConnexion } from '../../api/modeConnexion';
import { idProvisoire } from '../../lib/identifiants';
import { useSession } from '../../api/session.jsx';
import { adresseApi } from '../../api/client';
import {
  chantiersApi,
  depensesApi,
  employesApi,
  monEspaceApi,
  photosApi,
} from '../../api/resources';
import { dtoVersMessageEmploye } from '../../api/mappers';
import { RetourAchatDepot } from '../chantiers/RetourAchatDepot.jsx';
import { ajouteAuFil, marqueReponsesLues, reponsesNonLues } from '../../lib/messages-employe';
import { aQuitte, finDAcces } from '../../lib/personnel';
import { Shell } from '../../components/layout/Shell.jsx';
import { PhotoBtn } from '../../components/PhotoBtn.jsx';
import { SignaturePad } from '../../components/SignaturePad.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { BoutonCorriger, Inp } from '../../components/ui/Inputs.jsx';
import { Tabs } from '../../components/ui/Tabs.jsx';
import { SOC } from '../../constants/company';
import { ContratEmploye } from '../equipe/ContratEmploye.jsx';
import { FicheMensuelle } from '../equipe/FicheMensuelle.jsx';
import { ReleveHeuresDetail } from '../equipe/ReleveHeuresDetail.jsx';
import { LettreDemission } from '../equipe/LettreDemission.jsx';
import { DemanderDocument } from './DemanderDocument.jsx';
import { MesFormations } from './MesFormations.jsx';
import { MesConges } from './MesConges.jsx';
import { MesFichesDeSalaire } from './MesFichesDeSalaire.jsx';
import { ListeDocuments } from '../../components/ListeDocuments.jsx';
import { ListeFeuillesDepot } from '../../components/ListeFeuillesDepot.jsx';
import { ouvreDocument } from '../../api/documents.js';
import { MesLivraisons } from './MesLivraisons.jsx';
import { MesBonsAchat } from './MesBonsAchat.jsx';
import { StockMagasin } from './StockMagasin.jsx';
import { nonOuverts } from '../../lib/bons-achat';

import { formationDu } from '../../lib/costs';
import { prepareLeJustificatif } from '../../lib/justificatif';
import { litTexteTicket } from '../../lib/lecture-ticket';
import { texteDuJustificatif } from '../../lib/ocr-ticket';
import { DEVISE, fmt, fmtH } from '../../lib/currency';
import { RAYON_CHANTIER, distLisible, distM } from '../../lib/geo';

/**
 * Au-delà de ce délai, le pointage se passe de la position.
 *
 * <p>Un téléphone qui n'a pas répondu à la demande d'accès ne répond ni oui ni
 * non : sans ce délai, le geste restait suspendu indéfiniment et l'ouvrier
 * appuyait sans que rien ne se passe.
 */
const DELAI_POSITION_MS = 8000;
import { printDoc } from '../../lib/print';
import { retenuesSalariales, tauxEcrit } from '../../lib/retenues';
import { lignesDuPays } from '../../lib/charges';
import { dateSuisse } from '../../lib/dates';
import {
  corrigeLArrivee,
  departApresArrivee,
  ecartDuJour,
  finDeJournee,
  fmtEcart,
  pauseDuSegment,
  pauseLegale,
  phraseDuDepart,
  pointageRecouvert,
  pointagesDuJour,
  refermeLaJournee,
  totalDesJours,
} from '../../lib/pointage';
import { hours, today, uid, aujourdhuiIso } from '../../lib/utils';
import { C, docAcc } from '../../theme/palette';
import { localeDates, tr, trf } from '../../lib/i18n';
import { ChoixTravaux, lignesTravaux } from './ChoixTravaux.jsx';
import { useReglages } from '../../api/reglages.jsx';
import { reglagesPointage } from '../../lib/reglages-pointage';
import {
  BUREAU,
  CHANTIER,
  CLE_LIEUX_TRAVAIL,
  DEPOT,
  LIEUX_SANS_CHANTIER,
  TELETRAVAIL,
  aDesLieux,
  constatDuBadge,
  controleLieu,
  coordonnee,
  libelleLieu,
  lieuHabituel,
  lieuxDeLaSociete,
  lieuxDuReleve,
  lieuxPermis,
  marqueDuConstat,
  messageDuLieu,
  teletravailPrevu,
} from '../../lib/lieux-travail';
import { Constat } from '../lieux/Puces.jsx';

/** Le lieu de la fiche (BUREAU…) sous le nom que l'écran donne au choix du jour. */
const LIEU_ECRAN = {
  BUREAU: 'bureau',
  DEPOT: 'depot',
  TELETRAVAIL: 'teletravail',
  CHANTIER: 'chantier',
};
/** Le choix du jour qui pointe sur la fiche, et son lieu. */
const LIEU_FICHE = { bureau: 'BUREAU', depot: 'DEPOT', teletravail: 'TELETRAVAIL' };
import { NOM_LOGICIEL } from '../../lib/marque';
import { MaSecurite } from '../reglages/MaSecurite.jsx';

/**
 * Onglets sans objet pour le patron en mode terrain : il est la direction à
 * qui l'on écrit, et une lettre de démission ne s'adresse qu'à elle.
 */
const ONGLETS_DU_BUREAU = ['communication', 'demission'];

/**
 * « Mets SwissTech sur ton téléphone », dans l'espace de l'ouvrier, tant que
 * l'application n'est pas installée. L'invitation le proposait une fois ;
 * l'ouvrier qui passait au contrat sans l'installer devait ensuite retrouver
 * le lien chaque matin. L'icône installée d'ici s'ouvre à son nom : il n'y
 * tape que ses quatre chiffres.
 *
 * @param {object} props propriétés
 * @param {object} props.emp fiche de l'employé connecté
 * @param {object} [props.soc] société
 * @returns {import('react').ReactElement|null} le guide, ou rien une fois installée
 */
function InstallationOuvrier({ emp, soc }) {
  // Quand le code à six chiffres vaut pour tous, l'icône s'ouvre sur l'écran
  // de connexion, comme pour chacun : adresse, mot de passe, puis le code.
  const codeOuvrier = useModeConnexion()?.codeOuvrier === true;
  const retenu = ouvrierRetenu();
  const code = String(retenu?.codeEntreprise || soc?.codeOuvrier || '').toUpperCase();
  const employe = emp?.id;
  const installee = estInstallee();
  useEffect(() => {
    if (!codeOuvrier || installee || !code || !Number.isInteger(employe)) return;
    utiliseManifeste(
      `/api/public/manifeste/ouvrier?code=${encodeURIComponent(code)}&employe=${employe}`,
      { titre: NOM_LOGICIEL, depart: `/?ouvrier=${code}.${employe}` },
    );
  }, [codeOuvrier, installee, code, employe]);
  if (installee) return null;
  return (
    <GuideInstallation
      apres={
        codeOuvrier
          ? 'Chaque matin, tu touches l’icône et tu tapes juste tes 4 chiffres.'
          : 'Chaque matin, tu touches l’icône et tu te connectes avec ton adresse e-mail et ton mot de passe.'
      }
    />
  );
}

/**
 * Onglet sur lequel l'espace s'ouvre, d'après l'adresse.
 *
 * <p>L'invitation acceptée mène à `/?onglet=contrat` : le contrat à signer
 * s'ouvre de lui-même. Tout autre onglet, ou aucun, ouvre l'accueil.
 *
 * @param {string} recherche partie `?…` de l'adresse
 * @returns {string} l'onglet initial
 */
export function ongletInitial(recherche) {
  try {
    const onglet = new URLSearchParams(recherche || '').get('onglet');
    return onglet === 'contrat' ? 'contrat' : 'accueil';
  } catch {
    return 'accueil';
  }
}

/**
 * L'identifiant du chantier choisi dans la liste, du type de celui de la
 * collection. Le `<select>` rend une chaîne ; comparer « 12 » à 12 ne trouvait
 * rien, et le pointage se rattachait à aucun chantier alors que l'écran disait
 * « Arrivée pointée ».
 *
 * @param {Array} chantiers chantiers connus
 * @param {string} valeur valeur rendue par la liste
 * @returns {number|string} l'identifiant du chantier, tel que la collection le porte
 */
export function chantierChoisi(chantiers, valeur) {
  const trouve = (chantiers || []).find((c) => String(c.id) === String(valeur));
  return trouve ? trouve.id : valeur;
}

/**
 * La journée que l'ouvrier a ouverte et pas encore refermée, s'il y en a une.
 *
 * <p>Un pointage nommant un chantier appartient à ce chantier ; sans chantier,
 * il reste sur la fiche de l'employé. Mais la fiche, que le serveur compose,
 * recopie aussi les pointages de chantier, et elle n'est relue qu'à
 * l'ouverture de la page. Le départ pointé sur le chantier laissait donc sur la
 * fiche une copie sans heure de sortie : l'écran gardait « Pointer mon départ »
 * jusqu'au rechargement, et un second appui réécrivait l'heure de départ. Une
 * copie dont le chantier connaît la sortie n'est plus une journée ouverte.
 *
 * @param {Array} chantiers chantiers, avec leurs pointages
 * @param {object} emp fiche de l'employé connecté
 * @param {string} jour date du jour, au format ISO
 * @returns {{surChantier: object|null, ouverte: object|null}} le pointage ouvert
 *          sur un chantier, et celui qui fait foi (chantier d'abord, fiche sinon)
 */
export function journeeEnCours(chantiers, emp, jour) {
  const duJour = (chantiers || [])
    .flatMap((c) => (c.pointages || []).map((p) => ({ ...p, chId: c.id })))
    .filter((p) => p.empId === emp?.id && p.date === jour && p.entree);
  const surChantier = duJour.find((p) => !p.sortie) || null;
  const refermeeSurChantier = (b) => duJour.some((p) => p.sortie && p.entree === b.entree);
  const surLaFiche =
    (emp?.badges || []).find(
      (b) => b.date === jour && b.entree && !b.sortie && !refermeeSurChantier(b),
    ) || null;
  return { surChantier, ouverte: surChantier || surLaFiche };
}

/**
 * Pause à déduire des heures d'un rapport : celle du pointage du jour quand
 * le rapport en reprend les heures, sinon la pause de midi du contrat. Les
 * heures tapées à la main (« 07:00 – 16:30 ») ne déduisaient rien : 9 h 30 au
 * lieu de 8 h 30.
 *
 * @param {string} hd début
 * @param {string} hf fin
 * @param {object} [pt] pointage du jour sur ce chantier
 * @param {object} [emp] l'ouvrier, dont le contrat fixe la pause
 * @returns {number} la pause, en minutes
 */
export function pauseDuRapport(hd, hf, pt, emp) {
  if (pt && pt.sortie && pt.entree === hd && pt.sortie === hf) return +pt.pause || 0;
  return pauseLegale(hd, hf, emp);
}

export function EspaceOuvrier({
  onNav,
  soc,
  employes,
  setEmployes,
  chantiers,
  setChantiers,
  conges,
  setConges,
  rdv,
  stock,
  // Le stock ne s'écrit plus d'ici : sorties et retours passent par le serveur.
  rechargeStock,
  rechargeChantiers,
  feuilles,
  setFeuilles,
  estMixte,
  univers,
  setUnivers,
  // Un signal de la cloche ouvre l'onglet qui le concerne (plan, documents…).
  ouvrir,
  onOuvert,
  signaux,
}) {
  // L'ouvrier vient de s'identifier a l'entree : code de l'entreprise, son
  // nom, son code a quatre chiffres. Le lui redemander ici — sur un toit,
  // avec des gants — faisait deux fois le meme geste pour rien. Le compte
  // sait deja de qui il s'agit.
  //
  // Son espace est celui de sa fiche, et de nulle autre : la session la
  // designe, l'ecran ne la choisit pas. « Retour » ne le ramene donc pas a
  // une liste d'employes ou il pourrait en choisir un autre.
  const { session, deconnexion } = useSession();
  const estOuvrier = session?.role === 'ouvrier';
  const [empChoisi, setEmpChoisi] = useState(() => session?.employeId ?? null);
  // La session arrive parfois apres le premier rendu : l'adopter alors, mais
  // sans jamais ecraser un employe deja choisi a l'ecran.
  useEffect(() => {
    if (session?.employeId != null) {
      setEmpChoisi((precedent) => (precedent == null ? session.employeId : precedent));
    }
  }, [session?.employeId]);
  const empId = estOuvrier ? (session?.employeId ?? null) : empChoisi;
  // Le patron rattache a sa propre fiche y agit comme un ouvrier — pointage,
  // photos, rapport, achats, conges, salaire : c'est son « mode terrain ». Le
  // bureau qui ouvre l'espace d'un collegue, lui, ne fait que consulter. Le
  // titulaire de la fiche, ouvrier ou patron, ecrit par son espace.
  const modeTerrain = !estOuvrier && session?.employeId != null && empId === session.employeId;
  const titulaire = estOuvrier || modeTerrain;
  // Ses fiches de salaire emises, que la paie fermee a l'ouvrier ne lui
  // servait pas. Seul le titulaire de l'espace les lit : le bureau qui
  // consulte l'espace d'un employe n'a pas de fiche rattachee a son compte.
  const [fichesPaie, setFichesPaie] = useState([]);
  useEffect(() => {
    if (session?.employeId == null || session.employeId !== empId) return undefined;
    let actif = true;
    monEspaceApi
      .fichesPaie()
      .then((liste) => {
        if (actif) setFichesPaie(Array.isArray(liste) ? liste : []);
      })
      .catch(() => {
        if (actif) setFichesPaie([]);
      });
    return () => {
      actif = false;
    };
  }, [session?.employeId, empId]);
  // Ses lettres et certificats : la lettre de resiliation que la direction
  // emet, la demission qu'il remet, ses certificats. Relus apres une remise.
  const [mesDocuments, setMesDocuments] = useState([]);
  const [relectureDocs, setRelectureDocs] = useState(0);
  useEffect(() => {
    if (session?.employeId == null || session.employeId !== empId) return undefined;
    let actif = true;
    Promise.resolve()
      .then(() => monEspaceApi.documents())
      .then((liste) => {
        if (actif) setMesDocuments(Array.isArray(liste) ? liste : []);
      })
      .catch(() => {
        if (actif) setMesDocuments([]);
      });
    return () => {
      actif = false;
    };
  }, [session?.employeId, empId, relectureDocs]);
  // Arrive par son invitation, l'employe est mene droit a son contrat a
  // signer : l'adresse le dit (`/?onglet=contrat`).
  const [tab, setTab] = useState(() => ongletInitial(window.location.search));
  const [msgTxt, setMsgTxt] = useState('');
  // L'etat de signature de son contrat, lu au serveur : signe ou non, et si
  // les conditions ont change depuis. Seul le titulaire de l'espace le lit.
  const [contrat, setContrat] = useState(null);
  const litLeContrat = useCallback(() => {
    if (session?.employeId == null || typeof monEspaceApi.contrat !== 'function') return;
    monEspaceApi
      .contrat()
      .then((etat) => setContrat(etat || null))
      .catch(() => setContrat(null));
  }, [session?.employeId]);
  useEffect(() => {
    litLeContrat();
  }, [litLeContrat]);
  const signeLeContrat = async (trace) => {
    const etat = await monEspaceApi.signeContrat(trace);
    setContrat(etat);
    return etat;
  };
  const [msgEnvoi, setMsgEnvoi] = useState(false);
  const [msgErr, setMsgErr] = useState('');
  // Le chantier proposé au pointage : celui du planning du jour pour cet
  // employé, sinon un chantier en cours où il est affecté, sinon le premier en
  // cours. Avec plusieurs chantiers, prendre le premier de la liste rattachait
  // ses heures au chantier A alors que le bandeau disait « aujourd'hui : B ».
  const chantierDuJour = () => {
    const enCours = chantiers.filter((c) => c.statut === 'En cours');
    const jour = aujourdhuiIso();
    const planifie = (c, juste) =>
      (c.planif || []).some((x) => x.empId === empId && (!juste || x.date === jour));
    // Le chantier où il a pointé aujourd'hui d'abord : rouvrir l'application
    // dans la journée renvoyait au premier chantier, et le rapport, les photos
    // et le matériel partaient ailleurs que ses heures.
    const pointeIci = (c) => (c.pointages || []).some((p) => p.empId === empId && p.date === jour);
    const choisi =
      enCours.find(pointeIci) ||
      enCours.find((c) => planifie(c, true)) ||
      enCours.find((c) => planifie(c, false)) ||
      enCours[0];
    return choisi ? choisi.id : '';
  };
  const [chId, setChId] = useState(chantierDuJour);
  // Les chantiers arrivent du serveur apres le premier rendu : sans cette
  // reprise, le choix restait vide alors que la liste en affichait un, et le
  // pointage se rattachait a aucun chantier.
  // Le choix se refait aussi le lendemain (l'application restée ouverte la
  // nuit gardait le chantier de la veille) et quand le chantier retenu n'est
  // plus en cours : les heures partaient sur un chantier terminé.
  const [jourDuChoix, setJourDuChoix] = useState(aujourdhuiIso);
  useEffect(() => {
    const jour = aujourdhuiIso();
    const valable = chantiers.some((c) => c.id === chId && c.statut === 'En cours');
    if (chId && valable && jour === jourDuChoix) return;
    const id = chantierDuJour();
    if (id !== chId) setChId(id);
    if (jour !== jourDuChoix) setJourDuChoix(jour);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chId, chantiers]);
  // La cloche mène ici : l'onglet du signal, et son chantier pour un plan.
  useEffect(() => {
    if (!ouvrir || !ouvrir.onglet) return;
    setTab(ouvrir.onglet);
    if (ouvrir.chantierId != null && chantiers.some((c) => c.id === ouvrir.chantierId)) {
      setChId(ouvrir.chantierId);
    }
    if (onOuvert) onOuvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ouvrir]);
  const [pointe, setPointe] = useState(null);
  const [rapport, setRapport] = useState('');
  const [rapMeteo] = useState('☀ Beau');
  const [rapMateriel, setRapMateriel] = useState('');
  const [matCart, setMatCart] = useState({});
  // Matériel rapporté au dépôt, non utilisé, plutôt que pris.
  const [matRetour, setMatRetour] = useState(false);
  const [matEnvoi, setMatEnvoi] = useState(false);
  const [fEnvoi, setFEnvoi] = useState(false);
  // Postes de l'offre cochés (et travaux faits en plus) pour le rapport :
  // plusieurs d'un geste, sans tout réécrire.
  const [travauxRapport, setTravauxRapport] = useState([]);
  // Les choix du patron (Réglages → Pointage) : heures automatiques ou
  // manuelles, travaux cochés dans l'offre, écrits, ou les deux.
  const { reglage, reglageJson } = useReglages();
  const reglesPointage = reglagesPointage(reglage);
  // Heures automatiques : l'heure du téléphone fait foi pour l'employé. Le
  // patron, en mode terrain, garde la main sur les siennes.
  const heuresAuto = estOuvrier && reglesPointage.heures === 'auto';
  const travauxCoches = reglesPointage.travaux !== 'texte';
  const travauxEcrits = reglesPointage.travaux !== 'postes';
  // Atelier (Réglages → Pointage) : l'employé dit où il travaille aujourd'hui.
  // « chantier », « atelier_ch » (à l'atelier pour un chantier : ses heures
  // comptent sur ce chantier) ou « atelier » (travail général de l'atelier).
  const atelierActif = reglesPointage.atelier;
  // Bureau, dépôt, télétravail (fiche de l'employé) : son lieu habituel est
  // proposé d'abord ; rien de choisi, c'est celui-là.
  const [lieuJourChoisi, setLieuJour] = useState(null);
  // Le constat du pointage au bureau, au dépôt ou en télétravail.
  const [constatLieu, setConstatLieu] = useState(null);
  // L'heure de départ d'une journée passée restée ouverte, saisie après coup.
  const [departsOublies, setDepartsOublies] = useState({});
  // L'heure de départ inscrite à la main (vide : l'heure qu'il est), et la
  // correction de l'arrivée en cours (null : fermée).
  const [heureDepart, setHeureDepart] = useState('');
  // L'heure d'arrivée choisie avant de pointer (vide : l'heure qu'il est).
  const [heureArrivee, setHeureArrivee] = useState('');
  const [matCat, setMatCat] = useState('');
  // L'achat chez un fournisseur : l'enseigne, le montant du bon et sa photo,
  // qui font une depense en comptabilite en plus de la ligne de materiau.
  const [achatFourn, setAchatFourn] = useState('');
  const [achatMontant, setAchatMontant] = useState('');
  const [achatBon, setAchatBon] = useState(null);
  // La TVA lue sur le bon (taux et montant) : elle se récupère telle quelle.
  const [achatTva, setAchatTva] = useState(null);
  const [achatLecture, setAchatLecture] = useState('');
  const [achatEnvoi, setAchatEnvoi] = useState(false);
  const [achatErr, setAchatErr] = useState('');
  // Le bon joint (photo ou PDF) est lu dans le téléphone : fournisseur,
  // montant et TVA se remplissent, comme dans Dépenses.
  const joinsLeBon = async (fichier) => {
    setAchatErr('');
    try {
      setAchatBon(await prepareLeJustificatif(fichier));
    } catch (e) {
      setAchatErr(e?.message || 'La photo du bon n’a pas pu être jointe.');
      return;
    }
    setAchatLecture(tr('Lecture…'));
    try {
      const lu = litTexteTicket(await texteDuJustificatif(fichier), {
        nousMemes: [soc?.nom].filter(Boolean),
        pays: soc?.pays,
      });
      if (lu.fournisseur) setAchatFourn((f) => f || lu.fournisseur);
      if (lu.montantTtc != null) setAchatMontant(String(lu.montantTtc));
      setAchatTva(
        lu.montantTva != null
          ? { montantTva: +lu.montantTva, tauxTva: lu.tauxTva.length === 1 ? lu.tauxTva[0] : null }
          : null,
      );
      setAchatLecture(
        lu.montantTtc != null ? tr('✓ Facture lue : vérifie les champs avant d’enregistrer.') : '',
      );
    } catch {
      setAchatLecture('');
    }
  };
  const [photoNote, setPhotoNote] = useState('');
  const [photoCat, setPhotoCat] = useState('pendant');
  // Le travail photographié (« Étanchéité ») : le patron retrouve la photo
  // par ce poste des années après, si le client conteste.
  const [photoPoste, setPhotoPoste] = useState('');
  const [photoEnvoi, setPhotoEnvoi] = useState(false);
  const [photoErr, setPhotoErr] = useState('');
  const [showFiche, setShowFiche] = useState(false);
  const [showReleve, setShowReleve] = useState(false);
  // Le mois du relevé d'heures imprimé, par défaut le dernier travaillé.
  const [moisReleve, setMoisReleve] = useState('');
  const [showMensuel, setShowMensuel] = useState(false);
  const [noteDraft, setNoteDraft] = useState({});
  const [flash, setFlash] = useState('');
  const [fMode, setFMode] = useState('ouvrier');
  const [fOuvrier, setFOuvrier] = useState('');
  // L'employé ne charge que sa fiche : le magasinier lit au serveur le nom de
  // ses collègues, pour choisir à qui il remplit la feuille du dépôt.
  const [collegues, setCollegues] = useState([]);
  useEffect(() => {
    if (fMode !== 'magasinier' || session?.role !== 'ouvrier') return;
    if (typeof monEspaceApi.collegues !== 'function') return;
    let actif = true;
    Promise.resolve()
      .then(() => monEspaceApi.collegues())
      .then((l) => {
        if (actif) setCollegues(Array.isArray(l) ? l : []);
      })
      .catch(() => {});
    return () => {
      actif = false;
    };
  }, [fMode, session?.role]);
  const equipiers = session?.role === 'ouvrier' ? collegues : employes || [];
  // Prénom et nom : la fiche du bureau porte le nom de famille seul, et deux
  // « Exemple » ne se distinguaient plus dans la liste de l'employé servi.
  const nomComplet = (e) =>
    e?.prenom && !String(e.nom || '').includes(e.prenom)
      ? e.prenom + ' ' + (e.nom || '')
      : e?.nom || '';
  const [fChId, setFChId] = useState(() => {
    const _a = chantiers.filter((c) => c.statut === 'En cours');
    return _a.length ? _a[0].id : '';
  });
  const [fDate, setFDate] = useState(new Date().toLocaleDateString('fr-CH'));
  // L'heure où le matériel est pris au dépôt (vide : l'heure qu'il est).
  const [fHeure, setFHeure] = useState('');
  const [fCart, setFCart] = useState({});
  const [fQuery, setFQuery] = useState('');
  const lblF = {
    fontSize: 8.5,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: C.muted,
    margin: '11px 0 5px',
  };
  const selF = {
    width: '100%',
    border: '1px solid ' + C.border,
    borderRadius: 10,
    padding: '11px 10px',
    fontSize: 14,
    fontFamily: 'inherit',
    background: '#fff',
    boxSizing: 'border-box',
  };
  const todayISO = aujourdhuiIso();
  const emp = employes.find((e) => e.id === empId);
  // Les lieux réglés sur sa fiche : le magasinier pointe au dépôt, et sur un
  // chantier quand il y livre. Sans réglage, les chantiers comme toujours.
  const lieuxSociete = lieuxDeLaSociete(reglageJson(CLE_LIEUX_TRAVAIL, {}));
  const lieuxDuJour = emp && aDesLieux(emp) ? lieuxPermis(emp) : null;
  const lieuJour = lieuJourChoisi ?? LIEU_ECRAN[lieuxDuJour?.[0]] ?? 'chantier';
  // Le magasinier qui part sur un chantier y livre : « Livraison » d'office.
  const livreur = lieuHabituel(emp) === DEPOT;
  // L'onglet parait des que la fiche porte de quoi estimer le salaire, ou
  // qu'une fiche de salaire a ete emise. Il lisait `tauxH`, qui n'existe pas,
  // et la fiche de l'espace ne portait ni salaire ni taux : il ne paraissait
  // jamais pour un ouvrier.
  // Les réponses de la direction qu'il n'a pas encore lues : la pastille de
  // « Communication » les compte, et les éteint quand il ouvre son fil — pour
  // son compte seulement, au serveur.
  const aLire = reponsesNonLues(emp);
  useEffect(() => {
    if (tab !== 'communication' || aLire === 0 || !emp || !estOuvrier) return;
    if (setEmployes) setEmployes((p) => marqueReponsesLues(p, emp.id));
    if (session?.employeId != null && typeof monEspaceApi.messagesLus === 'function') {
      Promise.resolve()
        .then(() => monEspaceApi.messagesLus())
        .catch(() => {});
    }
  }, [tab, aLire, emp, estOuvrier, setEmployes, session?.employeId]);
  const libelleComm = (base) => (aLire > 0 ? base + ' (' + aLire + ')' : base);
  // Les messages du patron écrits depuis l'onglet « Msg » d'un chantier
  // restaient dans le chantier, qu'aucun écran de l'ouvrier ne montrait : ils
  // rejoignent son fil avec la direction, le nom du chantier en tête.
  const cleDate = (d) => (/^\d{4}-/.test(String(d || '')) ? String(d) : '9999');
  const filComm = [
    ...(emp?.messages || []),
    ...(chantiers || []).flatMap((c) =>
      (c.messages || [])
        .filter((m) => m.de === 'gerant' && m.contenu)
        .map((m) => ({ de: 'gerant', texte: '🏗 ' + c.nom + ' — ' + m.contenu, date: m.date })),
    ),
  ].sort((a, b) => cleDate(a.date).localeCompare(cleDate(b.date)));
  const aUnSalaire = !!(emp?.salBase || emp?.txH) || fichesPaie.length > 0;
  const estMagOuv = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  const chantierOuvert = (chantiers || []).some((c) => c.statut === 'En cours');
  // Les bons d'achat que le bureau lui a envoyés (matériaux d'un chantier, ou
  // marchandise pour le stock du magasin) : ceux qu'il n'a pas encore ouverts
  // se comptent sur la case et s'annoncent à l'accueil.
  const [bonsNonOuverts, setBonsNonOuverts] = useState(0);
  const avecBonsAchat = titulaire;
  useEffect(() => {
    if (!avecBonsAchat) return undefined;
    let actif = true;
    monEspaceApi
      .bonsAchat()
      .then((l) => actif && setBonsNonOuverts(nonOuverts(l)))
      .catch(() => {});
    return () => {
      actif = false;
    };
  }, [avecBonsAchat, tab]);
  const libelleBons = (base) => (bonsNonOuverts > 0 ? base + ' (' + bonsNonOuverts + ')' : base);

  // L'arrivee ne vivait que dans l'etat de l'ecran. Un telephone qui se
  // recharge, une page rouverte, et la matinee de l'ouvrier disparaissait —
  // ses heures, donc sa paie. Elle s'enregistre desormais des qu'elle est
  // pointee, la sortie vide, et c'est ce pointage ouvert qui fait foi : le
  // serveur le prevoit ainsi, « sortie vide tant que la journee court ».
  //
  // Un pointage nomme un chantier appartient a ce chantier ; sans chantier, il
  // reste sur la fiche de l'employe. Les deux endroits sont donc interroges.
  const { surChantier: ouvertSurChantier, ouverte: journeeOuverte } = journeeEnCours(
    chantiers,
    emp,
    todayISO,
  );

  /**
   * Enregistre l'arrivee, la sortie restant a venir : sur le chantier choisi,
   * ou sur la fiche (`surChantier` faux : atelier general, magasin).
   */
  const ouvreLaJournee = (entree, complement = {}, surChantier = true) => {
    if (!emp) return;
    const pointage = {
      id: uid(),
      empId: emp.id,
      empNom: emp.nom,
      date: todayISO,
      entree,
      sortie: '',
      pause: 0,
      type: 'normal',
      tache: '',
      ...complement,
    };
    if (surChantier && chId && setChantiers) {
      setChantiers((p) =>
        p.map((c) => (c.id === chId ? { ...c, pointages: [...(c.pointages || []), pointage] } : c)),
      );
      return;
    }
    setEmployes &&
      setEmployes((p) =>
        p.map((x) => (x.id === emp.id ? { ...x, badges: [...(x.badges || []), pointage] } : x)),
      );
  };

  /**
   * Demande la position, sans jamais faire attendre le pointage.
   *
   * <p>Un telephone qui n'a pas encore repondu a la demande d'acces laisse les
   * deux reponses en suspens : ni succes, ni echec. Le pointage etait pose
   * dans ces rappels-la, si bien que l'ouvrier appuyait et qu'il ne se passait
   * rien du tout. L'heure se note maintenant d'abord ; la position vient
   * ensuite si elle vient, avec un delai au-dela duquel on s'en passe.
   *
   * @param {(lat: number|null, lng: number|null) => void} quand suite du geste
   */
  const demandeLaPosition = (quand) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      quand(null, null);
      return;
    }
    let repondu = false;
    const unefois = (la, ln) => {
      if (repondu) return;
      repondu = true;
      quand(la, ln);
    };
    try {
      navigator.geolocation.getCurrentPosition(
        (po) => unefois(po.coords.latitude, po.coords.longitude),
        () => unefois(null, null),
        { timeout: DELAI_POSITION_MS, maximumAge: 60000 },
      );
    } catch (e) {
      unefois(null, null);
    }
    setTimeout(() => unefois(null, null), DELAI_POSITION_MS);
  };

  /**
   * Pointe l'arrivée au bureau, au dépôt ou en télétravail : sur la fiche,
   * l'heure d'abord, puis la position si elle vient — loin du lieu, l'heure
   * reste notée, « hors du bureau » ; le télétravail d'un jour non prévu
   * aussi, « à accepter ».
   */
  const pointeSurLaFiche = (entree, lieu) => {
    ouvreLaJournee(entree, { lieu }, false);
    setPointe({ entree, latE: null, lngE: null, onSiteE: null, lieu, general: true });
    setFlash(tr('✓ Arrivée pointée à') + ' ' + entree);
    if (lieu === TELETRAVAIL) {
      setConstatLieu(messageDuLieu(lieu, null, emp, todayISO));
      return;
    }
    demandeLaPosition((la, ln) => {
      const controle = controleLieu(lieu, la, ln, lieuxSociete);
      setConstatLieu(messageDuLieu(lieu, controle, emp, todayISO));
      if (typeof la !== 'number') return;
      setPointe((p) => (p ? { ...p, latE: la, lngE: ln, onSiteE: controle.surPlace } : p));
      setEmployes &&
        setEmployes((p) =>
          p.map((x) =>
            x.id === emp.id
              ? {
                  ...x,
                  badges: (x.badges || []).map((b) =>
                    b.chId == null && b.date === todayISO && b.entree === entree && !b.sortie
                      ? {
                          ...b,
                          latE: coordonnee(la),
                          lngE: coordonnee(ln),
                          onSiteEntree: controle.surPlace,
                        }
                      : b,
                  ),
                }
              : x,
          ),
        );
    });
  };

  /** Referme la journee en cours sur son heure de depart. */
  const fermeLaJournee = (sortie, complement = {}) => {
    if (!emp) return;
    if (ouvertSurChantier && setChantiers) {
      setChantiers((p) =>
        p.map((c) =>
          c.id === ouvertSurChantier.chId
            ? {
                ...c,
                pointages: refermeLaJournee(c.pointages, {
                  jour: todayISO,
                  sortie,
                  empId: emp.id,
                  complement,
                  emp,
                }),
              }
            : c,
        ),
      );
      return;
    }
    setEmployes &&
      setEmployes((p) =>
        p.map((x) =>
          x.id === emp.id
            ? {
                ...x,
                badges: refermeLaJournee(x.badges, { jour: todayISO, sortie, complement, emp }),
              }
            : x,
        ),
      );
  };

  /**
   * Corrige l'heure d'arrivée du jour : arrivé plus tôt ou plus tard que le
   * moment où il a pointé, l'employé inscrit son heure réelle.
   */
  const corrigeArriveeDuJour = (nouvelle) => {
    if (!emp || !/^\d{2}:\d{2}$/.test(nouvelle || '')) return;
    if (ouvertSurChantier && setChantiers) {
      setChantiers((p) =>
        p.map((c) =>
          c.id === ouvertSurChantier.chId
            ? {
                ...c,
                pointages: corrigeLArrivee(c.pointages, {
                  jour: todayISO,
                  nouvelle,
                  empId: emp.id,
                }),
              }
            : c,
        ),
      );
    } else if (setEmployes) {
      setEmployes((p) =>
        p.map((x) =>
          x.id === emp.id
            ? { ...x, badges: corrigeLArrivee(x.badges, { jour: todayISO, nouvelle }) }
            : x,
        ),
      );
    }
    setPointe((p) => (p ? { ...p, entree: nouvelle } : p));
    setFlash('✓ Arrivée corrigée à ' + nouvelle);
  };

  /**
   * Les heures du jour, côte à côte : l'arrivée à gauche, le départ à droite.
   * Avant d'avoir pointé, l'arrivée se choisit (arrivé plus tôt, pointé plus
   * tard) et le départ attend. Après, l'arrivée se corrige d'un geste et le
   * départ se règle à l'heure réelle — parti plus tôt, ou resté deux heures
   * de plus.
   *
   * @param {string} [entree] arrivée déjà pointée, ou rien avant l'arrivée
   */
  const heuresDuJour = (entree) => {
    const champ = {
      width: '100%',
      boxSizing: 'border-box',
      border: '1px solid ' + C.border,
      borderRadius: 10,
      minWidth: 0,
      padding: '9px 4px',
      fontSize: 19,
      fontWeight: 800,
      textAlign: 'center',
      background: C.white,
      color: C.ink,
    };
    const carte = (fond) => ({
      display: 'block',
      minWidth: 0,
      background: fond,
      borderRadius: 12,
      padding: '10px 10px 12px',
      textAlign: 'center',
    });
    const titre = { fontSize: 10, fontWeight: 800, color: C.grey, marginBottom: 6 };
    return (
      <>
        {/* Le jour pointé, en toutes lettres : on sait toujours de quel jour il s'agit. */}
        <div
          data-testid="jour-pointe"
          style={{
            background: C.navyXL,
            borderRadius: 10,
            padding: '8px 10px',
            marginBottom: 8,
            fontSize: 11.5,
            fontWeight: 800,
            color: C.navy,
            textAlign: 'center',
          }}
        >
          {trf('📅 Aujourd’hui · {0}', jourEnLettres(todayISO))}
        </div>
        <div
          data-testid="heures-du-jour"
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
            gap: 8,
            marginBottom: 11,
          }}
        >
          <label style={carte(C.greenL)}>
            <div style={titre}>🟢 Arrivée</div>
            <input
              type="time"
              aria-label="Heure d'arrivée"
              disabled={heuresAuto}
              value={entree || (heuresAuto ? '' : heureArrivee) || heureCourante()}
              onChange={(e) => {
                const v = e.target.value;
                if (!/^\d{2}:\d{2}$/.test(v)) return;
                if (entree) {
                  if (v !== entree) corrigeArriveeDuJour(v);
                } else setHeureArrivee(v);
              }}
              style={champ}
            />
          </label>
          <label style={carte(entree ? '#FDECEA' : C.navyXL)}>
            <div style={titre}>🔴 Départ</div>
            <input
              type="time"
              aria-label="Heure de départ"
              disabled={!entree || heuresAuto}
              value={entree ? (heuresAuto ? '' : heureDepart) || heureCourante() : ''}
              onChange={(e) => setHeureDepart(e.target.value)}
              style={{ ...champ, opacity: entree ? 1 : 0.45 }}
            />
          </label>
        </div>
        {heuresAuto && (
          <div
            data-testid="heures-automatiques"
            style={{ fontSize: 9, color: C.muted, textAlign: 'center', margin: '-4px 0 10px' }}
          >
            {tr('⏱ Heures automatiques : l’heure du téléphone au moment où tu pointes.')}
          </div>
        )}
      </>
    );
  };

  /** L'arrivée retenue avant de pointer : celle choisie, sinon l'heure qu'il est. */
  const arriveeRetenue = () => {
    const entree = (heuresAuto ? '' : heureArrivee) || heureCourante();
    setHeureArrivee('');
    return entree;
  };

  /**
   * L'heure de départ retenue, ou null si elle précède l'arrivée (l'employé
   * en est averti).
   */
  const departRetenu = (entree) => {
    const sortie = (heuresAuto ? '' : heureDepart) || heureCourante();
    if (!departApresArrivee(entree, sortie)) {
      setFlash('L’heure de départ doit suivre l’arrivée (' + entree + ').');
      return null;
    }
    setHeureDepart('');
    return sortie;
  };

  /** L'heure qu'il est, « 07:05 ». */
  const heureCourante = () => {
    const h = new Date();
    return String(h.getHours()).padStart(2, '0') + ':' + String(h.getMinutes()).padStart(2, '0');
  };

  /**
   * Transmet au bureau le rapport du jour (postes de l'offre cochés, détails,
   * remarques), rattaché au chantier, puis vide le formulaire.
   *
   * @param {*} chCible chantier du rapport
   * @param {{hd: string, hf: string, heures: number}} heures de la journée
   */
  const ajouteRapport = (chCible, { hd, hf, heures: hh }) => {
    const contenuRapport = [lignesTravaux(travauxRapport), rapport.trim()]
      .filter(Boolean)
      .join('\n\n');
    setChantiers((p) =>
      p.map((c) =>
        c.id === chCible
          ? {
              ...c,
              rapports: [
                ...(c.rapports || []),
                {
                  id: uid(),
                  // Sans l'identifiant, le serveur enregistrait
                  // `employeeId: null` : l'auteur etait vide au
                  // rechargement et le releve d'heures ne
                  // retrouvait plus les rapports de l'ouvrier.
                  empId: emp.id,
                  empNom: emp.nom,
                  date: today(),
                  contenu: contenuRapport,
                  meteo: rapMeteo,
                  materiel: rapMateriel,
                  hd,
                  hf,
                  heures: hh,
                },
              ],
              messages: [
                ...(c.messages || []),
                {
                  id: uid(),
                  de: 'ouvrier',
                  contenu:
                    '📋 Rapport ' +
                    rapMeteo +
                    (hh > 0 ? ' · ' + fmtH(hh) : '') +
                    ' : ' +
                    contenuRapport.slice(0, 70) +
                    (contenuRapport.length > 70 ? '…' : ''),
                  date: today().slice(0, 5),
                  h: '',
                  lu: false,
                },
              ],
            }
          : c,
      ),
    );
    setRapport('');
    setTravauxRapport([]);
    setRapMateriel('');
  };

  /** Le jour, en toutes lettres : « vendredi 17.10.2026 ». */
  const jourEnLettres = (iso) => {
    const d = new Date(String(iso).slice(0, 10) + 'T12:00:00');
    if (Number.isNaN(d.getTime())) return dateSuisse(iso);
    let nom = '';
    try {
      nom = d.toLocaleDateString(localeDates(), { weekday: 'long' });
    } catch {
      nom = '';
    }
    return (nom ? nom + ' ' : '') + dateSuisse(iso);
  };

  /**
   * Envoie un message au fil de la fiche ouverte.
   *
   * <p>Le message part seul : le serveur l'ajoute sans réécrire le fil, si
   * bien que la réponse de la direction, arrivée entre-temps, n'est plus
   * effacée. L'ouvrier écrit par son espace ; le bureau, qui consulte
   * l'espace d'un employé, écrit au nom de la direction.
   *
   * @param {string} texte contenu du message
   * @returns {Promise<boolean>} vrai si le message est parti
   */
  const envoieMessage = async (texte) => {
    if (!emp || !texte) return false;
    setMsgEnvoi(true);
    setMsgErr('');
    try {
      const dto = titulaire
        ? await monEspaceApi.ecrit(texte)
        : await employesApi.ecrit(emp.id, texte);
      if (setEmployes) setEmployes((p) => ajouteAuFil(p, emp.id, dtoVersMessageEmploye(dto)));
      return true;
    } catch (e) {
      setMsgErr(e?.message || 'Le message n’a pas pu être envoyé. Réessaie.');
      return false;
    } finally {
      setMsgEnvoi(false);
    }
  };

  // Le bureau ouvre l'espace d'un employe sans code : le patron accede deja a
  // tout. La garde comparait le code saisi a un code que l'ecran ne charge
  // jamais, si bien que celui de chacun valait « 0000 » — un controle qui
  // n'en etait pas un. Un vrai controle se fait au serveur, ou l'ouvrier ne
  // lit que sa propre fiche.
  if (!emp)
    return (
      <Shell
        active={estOuvrier ? 'ouvrier' : 'accueil'}
        onNav={onNav}
        soc={soc}
        pageTitle="👷 Espace employé"
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        {estOuvrier ? (
          <Card>
            <div style={{ padding: '16px 14px', fontSize: 11, color: C.grey, lineHeight: 1.55 }}>
              {empId == null
                ? 'Ce compte n’est rattaché à aucune fiche d’employé. Demande à ton responsable de t’inviter depuis ta fiche, dans « Équipe ».'
                : 'Chargement de ta fiche…'}
            </div>
          </Card>
        ) : (
          <>
            <div style={{ fontSize: 11, color: C.grey, marginBottom: 12 }}>
              Choisis l’employé dont tu veux ouvrir l’espace :
            </div>
            {employes.map((e) => (
              <Card
                key={e.id}
                style={{ marginBottom: 8, cursor: 'pointer' }}
                onClick={() => setEmpChoisi(e.id)}
              >
                <div
                  style={{ padding: '13px 14px', display: 'flex', alignItems: 'center', gap: 11 }}
                >
                  <div
                    style={{
                      width: 42,
                      height: 42,
                      borderRadius: 11,
                      background: e.col,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 900,
                    }}
                  >
                    {(e.nom || '?').charAt(0)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, fontWeight: 800 }}>{e.nom}</div>
                    <div style={{ fontSize: 9, color: C.muted }}>{e.role}</div>
                  </div>
                  <span style={{ color: C.muted }}>›</span>
                </div>
              </Card>
            ))}
          </>
        )}
      </Shell>
    );

  const mesPointages = chantiers
    .flatMap((c) =>
      (c.pointages || []).filter((p) => p.empId === emp.id).map((p) => ({ ...p, chNom: c.nom })),
    )
    // Du plus ancien au plus récent : « Mes derniers pointages » prend la fin.
    .sort((a, b) => `${a.date} ${a.entree}`.localeCompare(`${b.date} ${b.entree}`));
  // Le mois en cours, à l'heure locale : l'estimation du salaire additionnait
  // toutes les heures jamais pointées — au troisième mois, trois mois de paie.
  const moisCourant = (() => {
    const d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
  })();
  const pointagesDuMois = [
    ...mesPointages,
    // Les pointages hors chantier (magasin, dépôt) comptent aussi.
    ...((emp && emp.badges) || []).filter((b) => b.chId == null),
  ].filter((p) => String(p.date || '').slice(0, 7) === moisCourant);
  if (showFiche && emp) {
    const _da = docAcc(soc),
      accInk = _da.accInk;
    const totalH = pointagesDuMois.reduce(
      (s, p) => (p.type === 'absence' ? s : s + hours(p.entree, p.sortie, p.pause)),
      0,
    );
    // Les heures en plus se paient au taux normal : pas de majoration.
    const txH = emp.txH || 0;
    const brutHoraire = totalH * txH;
    // Sans taux horaire, le forfait mensuel vaut quoi qu'on ait pointe, comme
    // sur la fiche officielle : les heures du patron au mois ne valent pas zero.
    const auForfait = totalH <= 0 || txH <= 0;
    const brut = auForfait ? emp.salBase || 0 : brutHoraire;
    // Les retenues de sa fiche officielle : son taux LPP, ses
    // assujettissements et les taux de l'entreprise, que le serveur lui sert
    // (`cotisations`). Hors de Suisse, les cotisations du pays.
    const rFiche = retenuesSalariales(
      brut,
      emp,
      emp.tauxRetenues,
      lignesDuPays(soc, new Date().getFullYear(), emp.tauxRetenues?.canton),
    );
    const { soumis, taux, lpp, dAvs, dAc, dAanp, dIjm, dLpp, dCanton } = rFiche;
    const dIS = (brut * (emp.is || 0)) / 100;
    const ded = dAvs + dAc + dAanp + dIjm + dLpp + dCanton + dIS,
      net = brut - ded;
    const periode = new Date().toLocaleDateString(localeDates(), {
      month: 'long',
      year: 'numeric',
    });
    const dateEmis = new Date().toLocaleDateString('fr-CH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const Row = (lb, v, opt = {}) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          padding: '7px 0',
          borderBottom: opt.last ? 'none' : '1px solid #eef0f3',
          fontSize: 11,
        }}
      >
        <span
          style={{
            fontWeight: opt.b ? 700 : 400,
            color: opt.neg ? '#B00020' : opt.b ? '#0F1A2E' : '#3a4152',
          }}
        >
          {lb}
        </span>
        <span
          style={{
            fontWeight: opt.b ? 800 : 600,
            color: opt.neg ? '#B00020' : '#0F1A2E',
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {v}
        </span>
      </div>
    );
    return (
      <div
        className="doc-root"
        style={{
          height: '100%',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          background: '#4a4e57',
        }}
      >
        <style>
          {
            '.a4-sheet{width:100%;max-width:210mm}@media(max-width:520px){.a4-wrap{padding:10px 6px!important}.a4-sheet{padding:22px 16px!important}}@media print{@page{size:A4;margin:0}html,body{background:#fff!important;margin:0!important;padding:0!important}.no-print{display:none!important}.doc-root{height:auto!important;overflow:visible!important;background:#fff!important}.a4-wrap{margin:0!important;padding:0!important;background:#fff!important}.a4-sheet{box-shadow:none!important;margin:0!important;width:210mm!important;max-width:210mm!important;min-height:auto!important;padding:16mm 15mm!important}}'
          }
        </style>
        <div
          className="no-print"
          style={{
            background: accInk,
            color: '#fff',
            padding: '12px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 5,
          }}
        >
          <button
            onClick={() => setShowFiche(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ‹ Retour
          </button>
          <div style={{ display: 'flex', gap: 7 }}>
            <button
              onClick={printDoc}
              style={{
                background: C.green,
                border: 'none',
                color: '#fff',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 11,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              📄 PDF
            </button>
            <button
              onClick={printDoc}
              style={{
                background: 'rgba(255,255,255,.2)',
                border: '1px solid rgba(255,255,255,.45)',
                color: '#fff',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 11,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              🖨 Imprimer
            </button>
          </div>
        </div>
        <div
          className="no-print"
          style={{
            background: '#eceef1',
            color: '#555',
            padding: '7px 14px',
            fontSize: 9,
            textAlign: 'center',
            lineHeight: 1.4,
          }}
        >
          📱 iPhone : touche « Imprimer / PDF » → sur l'aperçu, touche le bouton Partager (carré
          avec flèche) en haut → « Enregistrer dans Fichiers ». · 💻 Ordinateur : « Imprimer » →
          destination « Enregistrer en PDF ».
        </div>
        <div
          className="a4-wrap"
          style={{ padding: '18px 12px', display: 'flex', justifyContent: 'center' }}
        >
          <div
            className="a4-sheet"
            style={{
              width: '100%',
              maxWidth: '210mm',
              minHeight: '297mm',
              background: '#fff',
              color: '#0F1A2E',
              boxSizing: 'border-box',
              padding: '16mm 15mm',
              boxShadow: '0 6px 24px rgba(0,0,0,.35)',
              fontFamily: "'Helvetica Neue',Arial,sans-serif",
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: '12px',
                paddingBottom: 16,
                borderBottom: '2.5px solid ' + accInk,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: 14,
                  alignItems: 'flex-start',
                  flex: '1 1 auto',
                  minWidth: 0,
                }}
              >
                {soc?.logo || SOC.logo ? (
                  <img
                    src={soc?.logo || SOC.logo}
                    style={{ width: 60, height: 60, objectFit: 'contain' }}
                    alt=""
                  />
                ) : (
                  <div
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: 10,
                      background: accInk,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 900,
                      fontSize: 26,
                    }}
                  >
                    {(soc?.nom || SOC.nom).charAt(0)}
                  </div>
                )}
                <div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: '#0F1A2E' }}>
                    {soc?.nom || SOC.nom}
                  </div>
                  <div style={{ fontSize: 10, color: '#5a6270', marginTop: 3, lineHeight: 1.5 }}>
                    {soc?.adr || SOC.adr}
                    <br />
                    {soc?.npa || SOC.npa}
                  </div>
                  {(soc?.tel || SOC.tel) && (
                    <div style={{ fontSize: 9.5, color: '#5a6270', marginTop: 4 }}>
                      Tél. {soc?.tel || SOC.tel}
                    </div>
                  )}
                  {(soc?.email || SOC.email) && (
                    <div style={{ fontSize: 9.5, color: '#5a6270' }}>{soc?.email || SOC.email}</div>
                  )}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    display: 'inline-block',
                    background: accInk,
                    color: '#fff',
                    fontWeight: 800,
                    fontSize: 14,
                    letterSpacing: 0.5,
                    padding: '7px 14px',
                    borderRadius: 6,
                  }}
                >
                  FICHE DE SALAIRE
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: '#3a4152',
                    textTransform: 'capitalize',
                    marginTop: 8,
                    fontWeight: 600,
                  }}
                >
                  Période : {periode}
                </div>
                <div style={{ fontSize: 9, color: '#8a909c', marginTop: 2 }}>
                  Émise le {dateEmis}
                </div>
              </div>
            </div>

            {(soc?.tva || SOC.tva) && (
              <div
                style={{
                  display: 'flex',
                  gap: 24,
                  fontSize: 8.5,
                  color: '#8a909c',
                  padding: '7px 0 0',
                }}
              >
                {(soc?.tva || SOC.tva) && <span>N° TVA : {soc?.tva || SOC.tva}</span>}
              </div>
            )}

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                border: '1px solid #e2e5ea',
                borderRadius: 10,
                overflow: 'hidden',
                margin: '18px 0 22px',
              }}
            >
              <div style={{ padding: '13px 16px', borderRight: '1px solid #e2e5ea' }}>
                <div
                  style={{
                    fontSize: 8,
                    color: '#8a909c',
                    textTransform: 'uppercase',
                    letterSpacing: 0.7,
                    fontWeight: 700,
                  }}
                >
                  Employé
                </div>
                <div style={{ fontWeight: 800, fontSize: 14.5, marginTop: 3 }}>{emp.nom}</div>
                <div style={{ fontSize: 10.5, color: '#5a6270', marginTop: 1 }}>{emp.role}</div>
                {emp.iban && (
                  <div style={{ fontSize: 8.5, color: '#8a909c', marginTop: 6 }}>
                    IBAN : {emp.iban}
                  </div>
                )}
              </div>
              <div style={{ padding: '13px 16px', background: '#fafbfc' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: 10,
                    padding: '2px 0',
                  }}
                >
                  <span style={{ color: '#8a909c' }}>Taux horaire</span>
                  <b>
                    {DEVISE} {fmt(emp.txH || 0)}/h
                  </b>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: 10,
                    padding: '2px 0',
                  }}
                >
                  <span style={{ color: '#8a909c' }}>Heures du mois</span>
                  <b>{fmtH(totalH)}</b>
                </div>
              </div>
            </div>

            <div
              style={{
                fontSize: 9.5,
                fontWeight: 800,
                color: accInk,
                textTransform: 'uppercase',
                letterSpacing: 0.6,
                marginBottom: 2,
              }}
            >
              Salaire — calcul
            </div>
            {auForfait ? (
              Row('Salaire mensuel forfaitaire', DEVISE + ' ' + fmt(emp.salBase || 0))
            ) : (
              <>
                {Row(
                  'Heures travaillées (au taux de ' + DEVISE + ' ' + fmt(txH) + '/h)',
                  fmtH(totalH),
                )}
                {Row(
                  fmtH(totalH) + ' × ' + DEVISE + ' ' + fmt(txH) + '/h',
                  DEVISE + ' ' + fmt(brutHoraire),
                )}
              </>
            )}
            {Row('Salaire brut', DEVISE + ' ' + fmt(brut), { b: true, last: true })}

            <div
              style={{
                fontSize: 9.5,
                fontWeight: 800,
                color: accInk,
                textTransform: 'uppercase',
                letterSpacing: 0.6,
                margin: '20px 0 2px',
              }}
            >
              Déductions salarié
            </div>
            {soumis.avs &&
              Row(
                'AVS / AI / APG (' + tauxEcrit(taux.avs) + '%)',
                '− ' + DEVISE + ' ' + fmt(dAvs),
                { neg: true },
              )}
            {soumis.ac &&
              Row(
                'Assurance chômage AC (' + tauxEcrit(taux.ac) + '%)',
                '− ' + DEVISE + ' ' + fmt(dAc),
                { neg: true },
              )}
            {soumis.aanp &&
              Row(
                'Assurance accident AANP (' + tauxEcrit(taux.aanp) + '%)',
                '− ' + DEVISE + ' ' + fmt(dAanp),
                { neg: true },
              )}
            {dIjm > 0 &&
              Row(
                'Indemnités journalières maladie IJM (' + tauxEcrit(taux.ijm) + '%)',
                '− ' + DEVISE + ' ' + fmt(dIjm),
                { neg: true },
              )}
            {rFiche.pays
              ? rFiche.detail.map((d) => (
                  <Fragment key={d.libelle}>
                    {Row(
                      d.libelle + ' (' + tauxEcrit(d.taux) + '%)',
                      '− ' + DEVISE + ' ' + fmt(d.montant),
                      { neg: true },
                    )}
                  </Fragment>
                ))
              : dCanton > 0 &&
                Row(
                  'Autres cotisations sociales (' + tauxEcrit(taux.canton) + '%)',
                  '− ' + DEVISE + ' ' + fmt(dCanton),
                  { neg: true },
                )}
            {soumis.lpp &&
              Row('Prévoyance LPP 2e pilier (' + lpp + '%)', '− ' + DEVISE + ' ' + fmt(dLpp), {
                neg: true,
              })}
            {dIS > 0 &&
              Row('Impôt à la source (' + (emp.is || 0) + '%)', '− ' + DEVISE + ' ' + fmt(dIS), {
                neg: true,
              })}
            {Row('Total des déductions', '− ' + DEVISE + ' ' + fmt(ded), {
              b: true,
              neg: true,
              last: true,
            })}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '6px 14px',
                background: accInk,
                color: '#fff',
                borderRadius: 12,
                padding: '18px 22px',
                marginTop: 24,
              }}
            >
              <div>
                <div style={{ fontSize: 13, fontWeight: 700 }}>Net à payer</div>
                <div style={{ fontSize: 8.5, color: 'rgba(255,255,255,.8)', marginTop: 2 }}>
                  Salaire brut moins déductions légales
                </div>
              </div>
              <span
                style={{
                  fontSize: 24,
                  fontWeight: 900,
                  fontVariantNumeric: 'tabular-nums',
                  whiteSpace: 'nowrap',
                  marginLeft: 'auto',
                }}
              >
                {DEVISE} {fmt(net)}
              </span>
            </div>
            {emp.iban && (
              <div style={{ fontSize: 10, color: '#5a6270', marginTop: 12, textAlign: 'right' }}>
                Versement sur IBAN <b>{emp.iban}</b>
              </div>
            )}

            {(() => {
              const droit = emp.conges || 25;
              const anCourant = new Date().getFullYear();
              const cs = (conges || []).filter((c) => c.empId === emp.id && c.statut !== 'Refusé');
              const estVac = (c) => !c.type || /vac|cong/i.test(c.type);
              const pris = cs
                .filter((c) => c.statut === 'Approuvé' && estVac(c))
                .reduce((a, c) => a + (c.jours || 0), 0);
              const attente = cs
                .filter((c) => c.statut === 'En attente' && estVac(c))
                .reduce((a, c) => a + (c.jours || 0), 0);
              const solde = droit - pris;
              const fd = dateSuisse;
              const Stat = (lb, v, col) => (
                <div
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    padding: '11px 5px',
                    border: '1px solid #e2e5ea',
                    borderRadius: 9,
                    background: (col || '#8a909c') + '0f',
                  }}
                >
                  <div
                    style={{
                      fontSize: 19,
                      fontWeight: 900,
                      color: col || '#0F1A2E',
                      lineHeight: 1,
                    }}
                  >
                    {v}
                  </div>
                  <div
                    style={{
                      fontSize: 7.5,
                      color: '#8a909c',
                      textTransform: 'uppercase',
                      letterSpacing: 0.4,
                      marginTop: 4,
                      fontWeight: 700,
                    }}
                  >
                    {lb}
                  </div>
                </div>
              );
              return (
                <div style={{ marginTop: 24 }}>
                  <div
                    style={{
                      fontSize: 9.5,
                      fontWeight: 800,
                      color: accInk,
                      textTransform: 'uppercase',
                      letterSpacing: 0.6,
                      marginBottom: 9,
                    }}
                  >
                    Vacances &amp; congés {anCourant}
                  </div>
                  <div style={{ display: 'flex', gap: 7, marginBottom: 12 }}>
                    {Stat('Droit / an', droit + ' j', accInk)}
                    {Stat('Pris', pris + ' j', C.teal)}
                    {Stat('En attente', attente + ' j', C.amber)}
                    {Stat('Solde restant', solde + ' j', solde >= 0 ? C.green : C.red)}
                  </div>
                  {cs.length > 0 && (
                    <div>
                      <div
                        style={{
                          fontSize: 8,
                          fontWeight: 700,
                          color: '#8a909c',
                          textTransform: 'uppercase',
                          letterSpacing: 0.4,
                          marginBottom: 3,
                        }}
                      >
                        Détail des absences
                      </div>
                      {cs.map((c, i) => (
                        <div
                          key={i}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontSize: 10,
                            padding: '5px 0',
                            borderBottom: '1px solid #eef0f3',
                          }}
                        >
                          <span style={{ textTransform: 'capitalize' }}>
                            {c.type || 'congé'} · {fd(c.debut)}
                            {c.fin && c.fin !== c.debut ? ' → ' + fd(c.fin) : ''}
                            {c.statut && c.statut !== 'Approuvé'
                              ? ' (' + c.statut.toLowerCase() + ')'
                              : ''}
                          </span>
                          <b style={{ whiteSpace: 'nowrap', marginLeft: 8 }}>{c.jours || 1} j</b>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}

            <div
              style={{
                marginTop: 44,
                paddingTop: 14,
                borderTop: '1px solid #dde1e6',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
              }}
            >
              <div style={{ fontSize: 8.5, color: '#a0a6b0', lineHeight: 1.6, maxWidth: '58%' }}>
                Document indicatif généré par SwissTech le {dateEmis}. Les taux et montants doivent
                être validés par votre fiduciaire ou caisse de compensation.
              </div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    borderTop: '1px solid #8a909c',
                    width: 160,
                    paddingTop: 5,
                    fontSize: 9,
                    color: '#8a909c',
                  }}
                >
                  Signature &amp; timbre employeur
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showReleve && emp) {
    const _da = docAcc(soc),
      accInk = _da.accInk;
    const dateEmis = new Date().toLocaleDateString('fr-CH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    return (
      <div
        className="doc-root"
        style={{
          height: '100%',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          background: '#4a4e57',
        }}
      >
        <style>
          {
            '.a4-sheet{width:100%;max-width:210mm}@media(max-width:520px){.a4-wrap{padding:10px 6px!important}.a4-sheet{padding:22px 16px!important}}@media print{@page{size:A4;margin:0}html,body{background:#fff!important;margin:0!important;padding:0!important}.no-print{display:none!important}.doc-root{height:auto!important;overflow:visible!important;background:#fff!important}.a4-wrap{margin:0!important;padding:0!important;background:#fff!important}.a4-sheet{box-shadow:none!important;margin:0!important;width:210mm!important;max-width:210mm!important;min-height:auto!important;padding:16mm 15mm!important}}'
          }
        </style>
        <div
          className="no-print"
          style={{
            background: accInk,
            color: '#fff',
            padding: '12px 14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 5,
          }}
        >
          <button
            onClick={() => setShowReleve(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ‹ Retour
          </button>
          <div style={{ display: 'flex', gap: 7 }}>
            <button
              onClick={printDoc}
              style={{
                background: C.green,
                border: 'none',
                color: '#fff',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 11,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              📄 PDF
            </button>
            <button
              onClick={printDoc}
              style={{
                background: 'rgba(255,255,255,.2)',
                border: '1px solid rgba(255,255,255,.45)',
                color: '#fff',
                borderRadius: 8,
                padding: '8px 14px',
                fontSize: 11,
                fontWeight: 800,
                cursor: 'pointer',
              }}
            >
              🖨 Imprimer
            </button>
          </div>
        </div>
        <div
          className="no-print"
          style={{
            background: '#eceef1',
            color: '#555',
            padding: '7px 14px',
            fontSize: 9,
            textAlign: 'center',
            lineHeight: 1.4,
          }}
        >
          📱 iPhone : touche « Imprimer / PDF » → sur l'aperçu, touche le bouton Partager (carré
          avec flèche) en haut → « Enregistrer dans Fichiers ». · 💻 Ordinateur : « Imprimer » →
          destination « Enregistrer en PDF ».
        </div>
        <div
          className="a4-wrap"
          style={{ padding: '18px 12px', display: 'flex', justifyContent: 'center' }}
        >
          <div
            className="a4-sheet"
            style={{
              width: '100%',
              maxWidth: '210mm',
              minHeight: '297mm',
              background: '#fff',
              color: '#0F1A2E',
              boxSizing: 'border-box',
              padding: '16mm 15mm',
              boxShadow: '0 6px 24px rgba(0,0,0,.35)',
              fontFamily: "'Helvetica Neue',Arial,sans-serif",
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: '12px',
                paddingBottom: 16,
                borderBottom: '2.5px solid ' + accInk,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: 14,
                  alignItems: 'flex-start',
                  flex: '1 1 auto',
                  minWidth: 0,
                }}
              >
                {soc?.logo || SOC.logo ? (
                  <img
                    src={soc?.logo || SOC.logo}
                    style={{ width: 60, height: 60, objectFit: 'contain' }}
                    alt=""
                  />
                ) : (
                  <div
                    style={{
                      width: 60,
                      height: 60,
                      borderRadius: 10,
                      background: accInk,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 900,
                      fontSize: 26,
                    }}
                  >
                    {(soc?.nom || SOC.nom).charAt(0)}
                  </div>
                )}
                <div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: '#0F1A2E' }}>
                    {soc?.nom || SOC.nom}
                  </div>
                  <div style={{ fontSize: 10, color: '#5a6270', marginTop: 3, lineHeight: 1.5 }}>
                    {soc?.adr || SOC.adr}
                    <br />
                    {soc?.npa || SOC.npa}
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div
                  style={{
                    display: 'inline-block',
                    background: accInk,
                    color: '#fff',
                    fontWeight: 800,
                    fontSize: 14,
                    letterSpacing: 0.5,
                    padding: '7px 14px',
                    borderRadius: 6,
                  }}
                >
                  RELEVÉ D'HEURES
                </div>
                <div style={{ fontSize: 9, color: '#8a909c', marginTop: 8 }}>
                  Émis le {dateEmis}
                </div>
              </div>
            </div>
            <div style={{ marginTop: 14 }}>
              <ReleveHeuresDetail
                emp={emp}
                chantiers={lieuxDuReleve(emp, chantiers, {
                  soc,
                  depotAdresse: lieuxSociete.depotAdresse,
                })}
                accInk={accInk}
                mois={moisReleve}
                onMois={setMoisReleve}
              />
            </div>
            <div
              style={{
                marginTop: 44,
                paddingTop: 14,
                borderTop: '1px solid #dde1e6',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
              }}
            >
              <div style={{ fontSize: 8.5, color: '#a0a6b0', lineHeight: 1.6, maxWidth: '58%' }}>
                Document généré par SwissTech le {dateEmis}.
              </div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    borderTop: '1px solid #8a909c',
                    width: 160,
                    paddingTop: 5,
                    fontSize: 9,
                    color: '#8a909c',
                  }}
                >
                  Signature
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (showMensuel && emp)
    return (
      <FicheMensuelle
        emp={emp}
        chantiers={chantiers}
        soc={soc}
        onClose={() => setShowMensuel(false)}
      />
    );
  const enCours = pointe || journeeOuverte || null;
  return (
    <Shell
      active={estOuvrier ? 'ouvrier' : 'accueil'}
      onNav={onNav}
      soc={soc}
      back={!estOuvrier}
      // Le patron en mode terrain revient au bureau, jamais a une liste ou
      // choisir un autre employe : il n'est pas enferme dans son espace.
      onBack={
        estOuvrier ? undefined : modeTerrain ? () => onNav('accueil') : () => setEmpChoisi(null)
      }
      pageTitle={modeTerrain ? '👷 Patron · mode terrain' : '👷 ' + (nomComplet(emp) || emp.nom)}
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      {flash && (
        <div
          style={{
            background: C.greenL,
            border: '1px solid ' + C.green + '30',
            borderRadius: 9,
            padding: '9px 12px',
            fontSize: 10,
            color: C.green,
            fontWeight: 700,
            marginBottom: 11,
          }}
        >
          {flash}
        </div>
      )}
      {modeTerrain && (
        <div
          data-testid="mode-terrain"
          style={{
            background: 'linear-gradient(135deg,' + C.navy + ',' + C.teal + ')',
            borderRadius: 11,
            padding: '10px 12px',
            marginBottom: 11,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 11, fontWeight: 900, color: '#fff' }}>
              ♛ Patron · mode terrain
            </div>
            <div style={{ fontSize: 8.5, color: 'rgba(255,255,255,.85)', lineHeight: 1.4 }}>
              Tu pointes, photographies et rapportes sur ta propre fiche, comme un employé. Tes
              congés et tes achats sont validés d’office.{' '}
              <span
                onClick={() => setEmpChoisi(null)}
                style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 700 }}
              >
                Voir l’espace d’un collègue ›
              </span>
            </div>
          </div>
          <Btn label="← Retour au bureau" sm color={C.amber} onClick={() => onNav('accueil')} />
        </div>
      )}
      {emp &&
        aQuitte(emp) &&
        (() => {
          // Le serveur ferme l'acces passe ce delai : le bandeau annonce la
          // meme date. Il se lisait mal sur une date venue du serveur (ISO),
          // et s'affichait avant meme la fin du contrat.
          const dernier = finDAcces(emp.dateFin);
          const jj = (d) =>
            String(d.getDate()).padStart(2, '0') +
            '.' +
            String(d.getMonth() + 1).padStart(2, '0') +
            '.' +
            d.getFullYear();
          const fin = String(emp.dateFin).includes('-') ? dateSuisse(emp.dateFin) : emp.dateFin;
          return (
            <div
              style={{
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: 10,
                padding: '11px 13px',
                fontSize: 11,
                color: '#92400e',
                marginBottom: 12,
                lineHeight: 1.55,
              }}
            >
              <b>⚠️ Ton contrat s'est terminé le {fin}.</b>
              <br />
              Tu as accès jusqu'au <b>{dernier ? jj(dernier) : '(environ 1 mois et demi)'}</b> pour
              récupérer tes documents (fiches de salaire, certificats, contrat). Après cette date,
              ton accès sera fermé — pense à tout télécharger.
            </div>
          );
        })()}
      <Tabs
        items={(estMagOuv
          ? [
              ['accueil', '🏠 Accueil'],
              ['pointage', '⏱ Pointage'],
              // Les convocations du bureau valent aussi au magasin.
              ['rdv', '📅 Planning'],
              ['livraison', '🚚 Livraison'],
              // Ce qui reste en rayon, le prix à donner au client, et ce qui
              // manque à signaler au bureau.
              ['stock', '📦 Stock'],
              // Photos et sortie du dépôt se rattachent à un chantier : sans
              // chantier ouvert, deux onglets qui ne pouvaient que refuser.
              ...(chantierOuvert
                ? [
                    ['photos', '📷 Photos'],
                    ['feuille', '📦 Dépôt'],
                  ]
                : []),
              ...(avecBonsAchat ? [['bonsachat', libelleBons('🧾 Bons d’achat')]] : []),
              ['communication', libelleComm('💬 Comm.')],
              ...(aUnSalaire ? [['salaire', '💰 Salaire']] : []),
              ['contrat', '📄 Contrat'],
              ['formation', '🎓 Formation'],
              ['signature', '✍ Signature'],
              ['vacances', '🌴 Vacances'],
              ['absence', '🤒 Maladie / Accident'],
              ['documents', '📂 Documents'],
              ['demission', '✍️ Démission'],
            ]
          : [
              ['accueil', '🏠 Accueil'],
              // Pointage et rapport ensemble : les heures et ce qui a été fait
              // se notent au même endroit, sans second onglet.
              ['pointage', '⏱ Pointage + rapport'],
              ['rdv', '📅 Planning'],
              ['photos', '📷 Photos'],
              // Le matériel en un seul endroit : sortie du dépôt (à quelle heure,
              // pour quel chantier), retour, achat fournisseur.
              ['materiel', '📦 Matériel'],
              ...(avecBonsAchat ? [['bonsachat', libelleBons('🧾 Bons d’achat')]] : []),
              ['communication', libelleComm('💬 Comm.')],
              ...(aUnSalaire ? [['salaire', '💰 Salaire']] : []),
              ['contrat', '📄 Contrat'],
              ['formation', '🎓 Formation'],
              ['signature', '✍ Signature'],
              ['vacances', '🌴 Vacances'],
              ['absence', '🤒 Maladie / Accident'],
              ['documents', '📂 Documents'],
              ['demission', '✍️ Démission'],
              ['plans', '📐 Plans'],
            ]
        ).filter(([cle]) => !modeTerrain || !ONGLETS_DU_BUREAU.includes(cle))}
        active={tab}
        onChange={setTab}
      />
      {tab === 'accueil' &&
        (() => {
          const items = estMagOuv
            ? [
                ['pointage', '⏱', 'Mes heures + ce que j’ai fait', C.teal],
                ['rdv', '📅', 'Planning / RDV', C.purple],
                ['livraison', '🚚', 'Mes livraisons', C.amber],
                ['stock', '📦', 'Stock du magasin', C.navy],
                // Comme les onglets : sans chantier ouvert, ces deux cases ne
                // pouvaient que refuser (« Choisis le chantier du matériel »).
                ...(chantierOuvert
                  ? [
                      ['photos', '📷', 'Photos', C.teal],
                      ['feuille', '📦', 'Préparer / dépôt', C.navy],
                    ]
                  : []),
                ...(avecBonsAchat
                  ? [
                      [
                        'bonsachat',
                        '🧾',
                        libelleBons('Bons d’achat'),
                        bonsNonOuverts > 0 ? C.red : C.green,
                      ],
                    ]
                  : []),
                ['communication', '💬', libelleComm('Communication'), aLire > 0 ? C.red : C.teal],
                ...(aUnSalaire ? [['salaire', '💰', 'Mon salaire', C.green]] : []),
                ['contrat', '📄', 'Mon contrat', C.navy],
                ['vacances', '🌴', 'Mes vacances', C.amber],
                ['absence', '🤒', 'Maladie / accident (certificat)', C.red],
                ['documents', '📂', 'Mes documents', C.navy],
                ['demission', '✍️', 'Lettre de démission', C.purple],
              ]
            : [
                ['pointage', '⏱', 'Mes heures + ce que j’ai fait', C.teal],
                ['rdv', '📅', 'Planning / RDV', C.purple],
                ['photos', '📷', 'Photos chantier', C.teal],
                ['materiel', '📦', 'Matériel du dépôt', C.navy],
                ...(avecBonsAchat
                  ? [
                      [
                        'bonsachat',
                        '🧾',
                        libelleBons('Bons d’achat'),
                        bonsNonOuverts > 0 ? C.red : C.green,
                      ],
                    ]
                  : []),
                ['communication', '💬', libelleComm('Communication'), aLire > 0 ? C.red : C.teal],
                ...(aUnSalaire ? [['salaire', '💰', 'Mon salaire', C.green]] : []),
                ['contrat', '📄', 'Mon contrat', C.navy],
                ['vacances', '🌴', 'Mes vacances', C.amber],
                ['absence', '🤒', 'Maladie / accident (certificat)', C.red],
                ['documents', '📂', 'Mes documents', C.navy],
                ['demission', '✍️', 'Lettre de démission', C.purple],
                ['plans', '📐', 'Plans', C.grey],
              ];
          const tuiles = items.filter(([t]) => !modeTerrain || !ONGLETS_DU_BUREAU.includes(t));
          return (
            <div>
              <div
                style={{
                  fontSize: 9.5,
                  fontWeight: 800,
                  color: C.muted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  marginBottom: 10,
                }}
              >
                Bonjour {emp.prenom || (emp.nom || '').split(' ')[0]} — mon espace
              </div>
              {(() => {
                // L'employé note ses heures chaque jour : le contrat dit la
                // journée prévue, mais il peut faire des heures sup ou partir
                // plus tôt. Un rappel quand il a oublié de pointer.
                if (!titulaire) return null;
                const maintenant = new Date();
                const jourSemaine = maintenant.getDay();
                if (jourSemaine === 0 || jourSemaine === 6) return null;
                const min = (t) => {
                  const m = /^(\d{1,2}):(\d{2})/.exec(String(t || ''));
                  return m ? +m[1] * 60 + +m[2] : null;
                };
                const now = maintenant.getHours() * 60 + maintenant.getMinutes();
                const duJour = pointagesDuMois.filter((p) => p.date === todayISO);
                const arrivee = min(emp.heureDebut || '07:00');
                const fin = min(
                  emp.heureFin || finDeJournee(emp.heureDebut || '07:00', emp.heuresJour, emp),
                );
                let texte = null;
                if (duJour.length === 0 && arrivee != null && now > arrivee + 30) {
                  texte = 'Tu n’as pas encore noté ton arrivée aujourd’hui';
                } else if (
                  duJour.some((p) => p.entree && !p.sortie) &&
                  fin != null &&
                  now > fin + 30
                ) {
                  texte = 'Pense à noter ton départ';
                }
                if (!texte) return null;
                return (
                  <div
                    role="status"
                    onClick={() => setTab('pointage')}
                    style={{
                      background: C.amber + '18',
                      border: '1px solid ' + C.amber,
                      borderRadius: 12,
                      padding: '10px 12px',
                      marginBottom: 10,
                      fontSize: 11.5,
                      fontWeight: 700,
                      color: C.ink,
                      cursor: 'pointer',
                    }}
                  >
                    ⏱ {texte} — touche pour pointer
                  </div>
                );
              })()}
              {titulaire && (signaux?.nonVus || 0) > 0 && (
                <div
                  role="status"
                  onClick={() => onNav && onNav('signaux')}
                  style={{
                    background: '#FBEDEB',
                    border: '2px solid ' + C.red,
                    borderRadius: 12,
                    padding: '10px 12px',
                    marginBottom: 10,
                    fontSize: 12,
                    fontWeight: 800,
                    color: C.ink,
                    cursor: 'pointer',
                  }}
                >
                  🔔 {trf('{0} nouveau(x) du bureau — touche pour voir', signaux.nonVus)}
                </div>
              )}
              {bonsNonOuverts > 0 && avecBonsAchat && (
                <div
                  role="status"
                  onClick={() => setTab('bonsachat')}
                  style={{
                    background: '#EEF8F1',
                    border: '2px solid ' + C.green,
                    borderRadius: 12,
                    padding: '10px 12px',
                    marginBottom: 10,
                    fontSize: 12,
                    fontWeight: 800,
                    color: C.ink,
                    cursor: 'pointer',
                  }}
                >
                  🧾{' '}
                  {bonsNonOuverts === 1
                    ? tr('Nouveau bon d’achat')
                    : trf('{0} nouveaux bons d’achat', bonsNonOuverts)}{' '}
                  — {tr('touche pour voir')}
                </div>
              )}
              {aLire > 0 && !modeTerrain && (
                <div
                  role="status"
                  onClick={() => setTab('communication')}
                  style={{
                    background: C.red + '14',
                    border: '1px solid ' + C.red,
                    borderRadius: 12,
                    padding: '10px 12px',
                    marginBottom: 10,
                    fontSize: 11.5,
                    fontWeight: 700,
                    color: C.ink,
                    cursor: 'pointer',
                  }}
                >
                  💬{' '}
                  {aLire === 1
                    ? 'La direction t’a répondu'
                    : 'La direction t’a écrit ' + aLire + ' messages'}{' '}
                  — touche pour lire
                </div>
              )}
              <InstallationOuvrier emp={emp} soc={soc} />
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
                  gap: 10,
                }}
              >
                {tuiles.map(([t, ic, lb, col]) => (
                  <div
                    key={t}
                    onClick={() => setTab(t)}
                    style={{
                      background: C.white,
                      border: '1px solid ' + C.border,
                      borderRadius: 14,
                      padding: '15px 10px',
                      cursor: 'pointer',
                      textAlign: 'center',
                      boxShadow: '0 1px 2px rgba(0,0,0,.04)',
                    }}
                  >
                    <div
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 12,
                        background: col + '1e',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 22,
                        margin: '0 auto 8px',
                      }}
                    >
                      {ic}
                    </div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: C.ink, lineHeight: 1.3 }}>
                      {lb}
                    </div>
                  </div>
                ))}
              </div>
              {/* L'employé ferme sa session : sur un téléphone prêté ou partagé,
                  personne d'autre n'entre dans son espace. */}
              {/* La deuxième sécurité n'est pas imposée à l'ouvrier : il
                  l'allume ici s'il le veut (sans effet entré par son code). */}
              {session?.role === 'ouvrier' && (
                <div style={{ marginTop: 16 }}>
                  <MaSecurite />
                </div>
              )}
              {session?.role === 'ouvrier' && (
                <div style={{ marginTop: 16 }}>
                  <Btn
                    label="🚪 Se déconnecter"
                    ghost
                    color={C.grey}
                    full
                    onClick={() => deconnexion()}
                  />
                </div>
              )}
            </div>
          );
        })()}
      {tab === 'livraison' && estMagOuv && <MesLivraisons setFlash={setFlash} />}
      {tab === 'stock' && estMagOuv && (
        <StockMagasin onSignale={envoieMessage} setFlash={setFlash} />
      )}
      {tab === 'bonsachat' && avecBonsAchat && (
        <MesBonsAchat
          soc={soc}
          setFlash={setFlash}
          onNonOuverts={setBonsNonOuverts}
          maSignature={emp.signature || ''}
          onSignature={(d) =>
            setEmployes?.((p) => p.map((x) => (x.id === emp.id ? { ...x, signature: d } : x)))
          }
        />
      )}
      {tab === 'contrat' && (
        <>
          {/* La formation convenue, en annexe de son contrat : elle ne change
              pas le contrat signé, elle a sa propre convention. */}
          {(emp.formation?.nom || +emp.formation?.cout > 0) && (
            <div
              role="button"
              onClick={() => setTab('formation')}
              style={{
                background: C.white,
                border: '1.5px solid ' + C.purple,
                borderRadius: 12,
                padding: '10px 12px',
                marginBottom: 10,
                fontSize: 11.5,
                cursor: 'pointer',
              }}
            >
              <div style={{ fontWeight: 800 }}>
                {trf('🎓 Formation convenue : {0}', emp.formation.nom || tr('Formation'))}
              </div>
              <div style={{ color: C.muted, marginTop: 2 }}>
                {+emp.formation.engagementMois > 0
                  ? trf(
                      'Engagement : {0} mois — convention signée dans l’onglet Formation',
                      emp.formation.engagementMois,
                    )
                  : tr('Convention dans l’onglet Formation')}
              </div>
            </div>
          )}
          <ContratEmploye
            emp={emp}
            soc={soc}
            onClose={() => setTab('accueil')}
            contrat={titulaire ? contrat : null}
            onSigne={titulaire ? signeLeContrat : undefined}
          />
        </>
      )}
      {tab === 'communication' && (
        <Card>
          <Bar
            icon="💬"
            title="Communication avec le bureau"
            color={C.teal}
            sub="Envoie un message à la direction"
          />
          <div style={{ padding: 13 }}>
            <MonChefEquipe />
            <div style={{ maxHeight: 280, overflowY: 'auto', marginBottom: 10 }}>
              {filComm.length === 0 ? (
                <div
                  style={{ fontSize: 10, color: C.muted, textAlign: 'center', padding: '18px 0' }}
                >
                  Aucun message pour le moment.
                  <br />
                  Écris ci-dessous pour contacter la direction.
                </div>
              ) : (
                filComm.map((m, i) => {
                  const moi = m.de === 'employe';
                  return (
                    <div
                      key={i}
                      style={{
                        display: 'flex',
                        justifyContent: moi ? 'flex-end' : 'flex-start',
                        marginBottom: 8,
                      }}
                    >
                      <div
                        style={{
                          maxWidth: '78%',
                          background: moi ? C.teal : C.navyXL,
                          color: moi ? '#fff' : C.ink,
                          borderRadius: 12,
                          padding: '8px 11px',
                          fontSize: 11,
                          lineHeight: 1.4,
                        }}
                      >
                        {m.texte}
                        <div
                          style={{ fontSize: 7.5, opacity: 0.7, marginTop: 3, textAlign: 'right' }}
                        >
                          {moi ? 'Moi' : 'Direction'} · {dateSuisse(m.date)}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            <textarea
              value={msgTxt}
              onChange={(e) => setMsgTxt(e.target.value)}
              placeholder="Ton message à la direction…"
              style={{
                width: '100%',
                boxSizing: 'border-box',
                minHeight: 64,
                border: '1px solid ' + C.border,
                borderRadius: 10,
                padding: '10px',
                fontSize: 12,
                fontFamily: 'inherit',
                resize: 'vertical',
              }}
            />
            {/* Un message tape sur un toit, avec des gants : le correcteur
                local des autres zones de texte lui revient aussi. */}
            <BoutonCorriger value={msgTxt} onChange={(e) => setMsgTxt(e.target.value)} />
            <div style={{ marginTop: 8 }}>
              <Btn
                label={msgEnvoi ? 'Envoi…' : '📨 Envoyer à la direction'}
                color={C.teal}
                full
                disabled={!msgTxt.trim() || msgEnvoi}
                onClick={async () => {
                  const texte = msgTxt.trim();
                  if (!texte || msgEnvoi) return;
                  if (await envoieMessage(texte)) setMsgTxt('');
                }}
              />
              {msgErr && (
                <div role="alert" style={{ fontSize: 10, color: C.red, marginTop: 6 }}>
                  {msgErr}
                </div>
              )}
            </div>
          </div>
        </Card>
      )}
      {tab === 'documents' && (
        <Card>
          <Bar
            icon="📂"
            title="Mes documents"
            color={C.navy}
            sub="Lettres et certificats, à ouvrir en PDF"
          />
          <div style={{ padding: 13 }}>
            <ListeDocuments
              documents={mesDocuments}
              cheminDe={(id) => `/mon-espace/documents/${id}`}
              vide="Aucun document pour l’instant. Ta lettre de démission, une lettre de résiliation ou tes certificats apparaissent ici dès qu’ils sont établis."
              titre="📂 Lettres et certificats"
            />
            {(() => {
              // Ce que le bureau lui a envoyé par « Envoyer à l'équipe » :
              // documents, et plans pour un lieu tapé à la main.
              const recus = (signaux?.liste || []).filter(
                (x) => x.envoiId && x.nomFichier && (x.type === 'DOCUMENT' || x.type === 'PLAN'),
              );
              if (!recus.length || typeof monEspaceApi.adresseFichierRecu !== 'function')
                return null;
              return (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 10, fontWeight: 800, color: C.muted, marginBottom: 6 }}>
                    {tr('📨 Reçus du bureau')}
                  </div>
                  {recus.map((x) => (
                    <a
                      key={x.id}
                      href={monEspaceApi.adresseFichierRecu(x.envoiId)}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => signaux.marqueVu(x.id)}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 8,
                        padding: '9px 0',
                        borderBottom: '1px solid ' + C.border,
                        fontSize: 12,
                        color: C.navy,
                        textDecoration: 'none',
                      }}
                    >
                      <span style={{ fontWeight: x.vuLe ? 600 : 800 }}>
                        {x.type === 'PLAN' ? '📐 ' : '📄 '}
                        {x.detail || x.nomFichier}
                      </span>
                      <span style={{ color: C.muted, whiteSpace: 'nowrap' }}>
                        {dateSuisse(x.creeLe)}
                      </span>
                    </a>
                  ))}
                </div>
              );
            })()}
            {titulaire && <DemanderDocument />}
          </div>
        </Card>
      )}
      {tab === 'demission' && (
        <div>
          <LettreDemission
            emp={emp}
            soc={soc}
            dejaRemise={mesDocuments.some((d) => d.type === 'LETTRE_DEMISSION')}
            onRemettre={
              titulaire
                ? async (valeurs) => {
                    // La lettre est figée au serveur, rangée dans le dossier, et
                    // le patron prévenu une seule fois : le bouton touché trois
                    // fois envoyait trois messages, sans jamais la lettre.
                    await ouvreDocument('/mon-espace/demission', undefined, valeurs);
                    setRelectureDocs((n) => n + 1);
                  }
                : undefined
            }
          />
          <div style={{ fontSize: 8.5, color: C.muted, textAlign: 'center', padding: '0 10px' }}>
            Ta lettre est rangée dans ton dossier, et le patron la lit en PDF.
          </div>
        </div>
      )}
      {!estMagOuv &&
        (() => {
          const mc = chantiers.filter((c) =>
            (c.planif || []).some((x) => x.date === todayISO && x.empId === emp.id),
          );
          if (!mc.length) return null;
          return (
            <div
              style={{
                background: C.tealL,
                border: '1px solid ' + C.teal + '40',
                borderRadius: 11,
                padding: '11px 13px',
                margin: '11px 0',
              }}
            >
              <div
                style={{
                  fontSize: 8.5,
                  fontWeight: 800,
                  color: C.teal,
                  textTransform: 'uppercase',
                  marginBottom: 3,
                }}
              >
                📍 Ton chantier aujourd'hui
              </div>
              {mc.map((c) => (
                <div key={c.id} style={{ fontSize: 12, fontWeight: 800, color: C.ink }}>
                  {c.nom}
                  {c.adr ? (
                    <span style={{ fontSize: 11, fontWeight: 600, color: C.muted }}>
                      {' '}
                      — {c.adr}
                    </span>
                  ) : null}
                </div>
              ))}
            </div>
          );
        })()}
      <div style={{ marginTop: 12 }} />

      {tab === 'feuille' && estMagOuv && (
        <Card>
          <Bar
            icon="📦"
            title="Sortie de matériel du dépôt"
            color={C.teal}
            sub="Quel matériel, à quelle heure, pour quel chantier"
          />
          <div style={{ padding: 13 }}>
            <Tabs
              items={[
                ['ouvrier', '👷 Moi'],
                ['magasinier', '🏭 Magasinier'],
              ]}
              active={fMode}
              onChange={setFMode}
            />
            {fMode === 'magasinier' && (
              <div>
                <div style={lblF}>Employé concerné</div>
                <select value={fOuvrier} onChange={(e) => setFOuvrier(e.target.value)} style={selF}>
                  <option value="">— choisir —</option>
                  {equipiers
                    .filter((e) => e.id !== emp.id)
                    .map((e) => (
                      <option key={e.id} value={String(e.id)}>
                        {nomComplet(e)}
                      </option>
                    ))}
                </select>
              </div>
            )}
            <div style={lblF}>Chantier</div>
            {/* Sans chantier ouvert, la liste restait vide sans explication :
                le matériel du dépôt sort toujours vers un chantier. */}
            {chantiers.some((c) => c.statut === 'En cours') ? (
              <select value={fChId} onChange={(e) => setFChId(e.target.value)} style={selF}>
                {chantiers
                  .filter((c) => c.statut === 'En cours')
                  .map((c) => (
                    <option key={c.id} value={c.id}>
                      {nomDuChantier(c, chantiers)}
                    </option>
                  ))}
              </select>
            ) : (
              <div
                style={{
                  fontSize: 10,
                  color: C.grey,
                  background: C.navyXL,
                  borderRadius: 9,
                  padding: '8px 11px',
                }}
              >
                Aucun chantier en cours : le matériel du dépôt sort vers un chantier ouvert par le
                bureau.
              </div>
            )}
            {(() => {
              const c = chantiers.find((x) => x.id === fChId);
              const a = c ? [c.adr, c.npa].filter(Boolean).join(', ') : '';
              return a ? (
                <div
                  style={{
                    fontSize: 10,
                    color: C.grey,
                    background: C.navyXL,
                    borderRadius: 9,
                    padding: '8px 11px',
                    marginTop: 6,
                  }}
                >
                  📍 {a}
                </div>
              ) : null;
            })()}
            <div style={lblF}>Date</div>
            <input value={fDate} onChange={(e) => setFDate(e.target.value)} style={selF} />
            {/* Les heures se pointent dans ⏱ Pointage, les travaux s'écrivent
                dans 📋 Rapport : ici, seulement le matériel, l'heure où il
                est pris et le chantier auquel il va. */}
            <div style={lblF}>Heure de prise</div>
            <input
              type="time"
              aria-label="Heure de prise du matériel"
              value={fHeure || heureCourante()}
              onChange={(e) => setFHeure(e.target.value)}
              style={{ ...selF, textAlign: 'center' }}
            />
            <div
              style={{
                fontSize: 9,
                fontWeight: 800,
                color: C.muted,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                margin: '15px 0 6px',
              }}
            >
              Matériel pris au dépôt
            </div>
            <input
              value={fQuery}
              onChange={(e) => setFQuery(e.target.value)}
              placeholder="🔎 Cherche un article du stock…"
              style={selF}
            />
            <div
              style={{
                border: '1px solid ' + C.border,
                borderRadius: 11,
                overflow: 'hidden',
                marginTop: 8,
                maxHeight: 230,
                overflowY: 'auto',
              }}
            >
              {(stock || [])
                .filter((a) => {
                  const q = fQuery.trim().toLowerCase();
                  return (
                    !q ||
                    (a.nom || '').toLowerCase().includes(q) ||
                    (a.ref || '').toLowerCase().includes(q)
                  );
                })
                .map((a) => {
                  const rem = (a.stock || 0) - (fCart[a.id] || 0);
                  return (
                    <div
                      key={a.id}
                      onClick={() => setFCart((p) => ({ ...p, [a.id]: (p[a.id] || 0) + 1 }))}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 9,
                        padding: '10px 12px',
                        borderBottom: '1px solid ' + C.border,
                        cursor: 'pointer',
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 11.5, fontWeight: 700, color: C.ink }}>{a.nom}</div>
                        <div style={{ fontSize: 9, color: C.muted }}>
                          {a.ref}
                          {a.u ? ' · ' + a.u : ''}
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          fontWeight: 800,
                          color: rem <= 3 ? C.red : C.grey,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {rem} en stock
                      </div>
                      <div
                        style={{
                          width: 26,
                          height: 26,
                          borderRadius: 13,
                          background: C.green,
                          color: '#fff',
                          fontSize: 17,
                          fontWeight: 800,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        +
                      </div>
                    </div>
                  );
                })}
            </div>
            {(() => {
              const refs = Object.keys(fCart).filter((k) => fCart[k] > 0);
              if (!refs.length) return null;
              const tot = refs.reduce((x, k) => x + fCart[k], 0);
              return (
                <div
                  style={{
                    background: C.greenL,
                    border: '1px solid #bfe0cc',
                    borderRadius: 12,
                    padding: 11,
                    marginTop: 10,
                  }}
                >
                  <div
                    style={{
                      fontSize: 9,
                      fontWeight: 800,
                      color: C.green,
                      textTransform: 'uppercase',
                      letterSpacing: 0.4,
                      marginBottom: 8,
                    }}
                  >
                    Matériel pris — {tot} article{tot > 1 ? 's' : ''}
                  </div>
                  {refs.map((k) => {
                    const a = (stock || []).find((m) => String(m.id) === String(k));
                    if (!a) return null;
                    const ov = fCart[k] > (a.stock || 0);
                    return (
                      <div
                        key={k}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          background: '#fff',
                          borderRadius: 9,
                          padding: 8,
                          marginBottom: 7,
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, fontWeight: 700 }}>{a.nom}</div>
                          <div style={{ fontSize: 9, color: ov ? C.red : C.muted }}>
                            reste après sortie : {Math.max(0, (a.stock || 0) - fCart[k])}
                            {ov ? ' · ⚠ stock insuffisant' : ''}
                          </div>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid ' + C.border,
                            borderRadius: 8,
                            overflow: 'hidden',
                          }}
                        >
                          <div
                            onClick={() =>
                              setFCart((p) => {
                                const n = { ...p };
                                n[k] = Math.max(0, (n[k] || 0) - 1);
                                if (!n[k]) delete n[k];
                                return n;
                              })
                            }
                            style={{
                              width: 30,
                              height: 30,
                              background: C.navyXL,
                              color: C.navy,
                              fontSize: 16,
                              fontWeight: 800,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            −
                          </div>
                          <div
                            style={{
                              width: 34,
                              textAlign: 'center',
                              fontSize: 13,
                              fontWeight: 800,
                            }}
                          >
                            {fCart[k]}
                          </div>
                          <div
                            onClick={() => setFCart((p) => ({ ...p, [k]: (p[k] || 0) + 1 }))}
                            style={{
                              width: 30,
                              height: 30,
                              background: C.navyXL,
                              color: C.navy,
                              fontSize: 16,
                              fontWeight: 800,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            ＋
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
            <Btn
              label="✓ Valider la feuille du jour"
              color={C.green}
              full
              disabled={fEnvoi}
              onClick={async () => {
                if (fEnvoi) return;
                // Le choix du chantier arrive en texte : comparé tel quel à
                // l'identifiant numérique, il ne trouvait rien (« — »).
                const c = chantiers.find((x) => String(x.id) === String(fChId));
                const refs = Object.keys(fCart).filter((k) => fCart[k] > 0);
                // Au dépôt, le magasinier remplit la feuille du collègue qu'il
                // sert : la feuille et la sortie de stock sont à ce collègue.
                const concerne =
                  fMode === 'magasinier'
                    ? equipiers.find((e) => String(e.id) === String(fOuvrier))
                    : emp;
                if (!concerne) {
                  setFlash('Choisis l’employé concerné.');
                  return;
                }
                const who = concerne.nom;
                const lignes = refs
                  .map((k) => {
                    const a = (stock || []).find((m) => String(m.id) === String(k));
                    return a ? { ref: a.ref, nom: a.nom, u: a.u, qte: fCart[k] } : null;
                  })
                  .filter(Boolean);
                // Une feuille sans article n'enregistrait rien, mais annonçait
                // « stock mis à jour ».
                if (refs.length === 0) {
                  setFlash('Ajoute au moins un article.');
                  return;
                }
                if (refs.length > 0) {
                  if (!c) {
                    setFlash('Choisis le chantier du matériel.');
                    return;
                  }
                  // Le matériel sort du stock et s'inscrit au coût du chantier
                  // en une seule opération du serveur, au prix d'achat.
                  setFEnvoi(true);
                  try {
                    await chantiersApi.depot(c.id, {
                      retour: false,
                      employeId: fMode === 'magasinier' ? concerne.id : undefined,
                      lignes: refs.map((k) => ({ articleId: Number(k), quantite: fCart[k] })),
                    });
                  } catch (e) {
                    setFlash('⚠️ ' + (e?.message || tr("L'enregistrement a échoué.")));
                    return;
                  } finally {
                    setFEnvoi(false);
                  }
                  Promise.all([rechargeStock?.(), rechargeChantiers?.()]).catch(() => {});
                }
                const prise = fHeure || heureCourante();
                const rec = {
                  // Un identifiant provisoire, non numerique : la synchronisation
                  // cree la feuille. Un nombre tire de l'horloge passait pour
                  // un identifiant de la base, et la feuille partait en mise a
                  // jour d'une ligne qui n'existait pas.
                  id: idProvisoire(),
                  date: fDate,
                  empId: concerne.id,
                  empNom: who,
                  par: fMode,
                  chId: c ? c.id : fChId,
                  chNom: c ? c.nom : '—',
                  adr: c ? [c.adr, c.npa].filter(Boolean).join(', ') : '',
                  // L'heure où le matériel a été pris ; les heures de travail
                  // se pointent à part.
                  heures: 0,
                  heuresLbl: '',
                  deb: prise,
                  fin: '',
                  pause: 0,
                  travaux: '',
                  lignes,
                };
                setFeuilles && setFeuilles((p) => [rec, ...(p || [])]);
                setFCart({});
                setFHeure('');
                setFQuery('');
                setFOuvrier('');
                setFlash('Feuille enregistrée — stock mis à jour.');
              }}
              style={{ marginTop: 13 }}
            />
            {/* Les siennes et celles qu'il a remplies au dépôt pour un collègue :
                le bureau qui ouvre l'espace d'un employé ne lit que les
                feuilles de cet employé, pas celles de toute l'équipe. */}
            <ListeFeuillesDepot
              feuilles={(feuilles || []).filter(
                (f) => f.empId === emp.id || f.saisiParId === emp.id,
              )}
              employes={[...(employes || []), ...collegues]}
            />
          </div>
        </Card>
      )}

      {tab === 'pointage' && estMagOuv && (
        <Card>
          <Bar
            icon="🕐"
            title="Pointer mes heures"
            color={C.amber}
            sub="Badge d'arrivée et de départ"
          />
          <div style={{ padding: 13 }}>
            {(() => {
              const enC = (pointe && pointe.simple ? pointe : null) || journeeOuverte || null;
              return (
                <>
                  <div
                    style={{
                      border: '1px solid ' + C.border,
                      borderRadius: 10,
                      padding: '11px 12px',
                      marginBottom: 11,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ flex: 1, marginRight: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: 700 }}>
                          📍 Partage de ma position (GPS)
                        </div>
                        <div style={{ fontSize: 8, color: C.muted }}>
                          {emp.gps?.actif
                            ? 'Activé' + (emp.gps.at ? ' · maj ' + emp.gps.at : '')
                            : "Désactivé — ta position n'est pas partagée"}
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          if (emp.gps?.actif) {
                            setEmployes &&
                              setEmployes((p) =>
                                p.map((x) =>
                                  x.id === emp.id
                                    ? { ...x, gps: { ...(x.gps || {}), actif: false } }
                                    : x,
                                ),
                              );
                            setFlash('Partage GPS désactivé');
                          } else {
                            if (typeof navigator !== 'undefined' && navigator.geolocation) {
                              navigator.geolocation.getCurrentPosition(
                                (po) => {
                                  const h = new Date();
                                  // `at` ne sert qu'a l'affichage ; c'est `maj`
                                  // qui date le releve, une heure seule ne
                                  // disant pas de quel jour il est.
                                  const at =
                                    String(h.getHours()).padStart(2, '0') +
                                    ':' +
                                    String(h.getMinutes()).padStart(2, '0');
                                  const maj = h.toISOString();
                                  setEmployes &&
                                    setEmployes((p) =>
                                      p.map((x) =>
                                        x.id === emp.id
                                          ? {
                                              ...x,
                                              gps: {
                                                actif: true,
                                                lat: po.coords.latitude,
                                                lng: po.coords.longitude,
                                                at,
                                                maj,
                                              },
                                            }
                                          : x,
                                      ),
                                    );
                                  setFlash('✓ Position partagée avec le bureau');
                                },
                                () => setFlash('⚠ Autorisation GPS refusée'),
                              );
                            } else {
                              setEmployes &&
                                setEmployes((p) =>
                                  p.map((x) =>
                                    x.id === emp.id ? { ...x, gps: { actif: true, at: '' } } : x,
                                  ),
                                );
                              setFlash('GPS activé');
                            }
                          }
                        }}
                        style={{
                          width: 46,
                          height: 26,
                          borderRadius: 99,
                          background: emp.gps?.actif ? C.green : C.border,
                          position: 'relative',
                          cursor: 'pointer',
                          flexShrink: 0,
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            top: 2,
                            left: emp.gps?.actif ? 22 : 2,
                            width: 22,
                            height: 22,
                            borderRadius: '50%',
                            background: '#fff',
                            transition: 'left .15s',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {heuresDuJour(enC ? enC.entree : '')}
                  {!enC ? (
                    <Btn
                      label="🟢 Pointer mon arrivée"
                      color={C.green}
                      full
                      onClick={() => {
                        const entree = arriveeRetenue();
                        ouvreLaJournee(entree);
                        setPointe({ simple: true, entree });
                        setFlash('✓ Arrivée pointée à ' + entree);
                      }}
                    />
                  ) : (
                    <div>
                      {/* Ce qui a été fait dans la journée : réception,
                          mise en rayon, livraisons… Il part avec les heures
                          et se lit dans le relevé du mois. */}
                      <textarea
                        aria-label="Ce que j’ai fait aujourd’hui"
                        placeholder="Ce que j’ai fait aujourd’hui (facultatif)"
                        value={rapport}
                        onChange={(e) => setRapport(e.target.value)}
                        rows={3}
                        style={{
                          width: '100%',
                          boxSizing: 'border-box',
                          border: '1px solid ' + C.border,
                          borderRadius: 9,
                          padding: '8px 10px',
                          fontSize: 11,
                          fontFamily: 'inherit',
                          marginBottom: 8,
                        }}
                      />
                      <Btn
                        label="🔴 Pointer mon départ"
                        color={C.red}
                        full
                        onClick={() => {
                          const sortie = departRetenu(enC.entree);
                          if (!sortie) return;
                          fermeLaJournee(sortie, rapport.trim() ? { tache: rapport.trim() } : {});
                          setRapport('');
                          setPointe(null);
                          // Ses heures du jour face au contrat : heures sup ou
                          // départ plus tôt, il le voit tout de suite.
                          const bilan = phraseDuDepart(enC.entree, sortie, emp);
                          setFlash(
                            '✓ Journée enregistrée (' +
                              enC.entree +
                              ' → ' +
                              sortie +
                              ')' +
                              (bilan ? ' · ' + bilan : ''),
                          );
                        }}
                      />
                    </div>
                  )}
                  <div style={{ fontSize: 8.5, color: C.muted, textAlign: 'center', marginTop: 8 }}>
                    Tes heures alimentent automatiquement ta fiche de salaire.
                  </div>
                  {emp.badges && emp.badges.length > 0 && (
                    <div style={{ marginTop: 13 }}>
                      <div
                        style={{
                          fontSize: 9,
                          fontWeight: 800,
                          color: C.muted,
                          textTransform: 'uppercase',
                          letterSpacing: 0.4,
                          marginBottom: 6,
                        }}
                      >
                        Derniers pointages
                      </div>
                      {/* Les plus récents d'abord, par date et heure : dans
                          l'ordre d'arrivée, un pointage corrigé après coup
                          passait devant celui du jour. */}
                      {[...emp.badges]
                        .sort((x, y) =>
                          (cleJour(y.date) + (y.entree || '')).localeCompare(
                            cleJour(x.date) + (x.entree || ''),
                          ),
                        )
                        .slice(0, 6)
                        .map((b, i) => {
                          const fd = dateSuisse;
                          const h = hours(b.entree, b.sortie, b.pause || 0);
                          return (
                            <div
                              key={i}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid ' + C.border,
                                padding: '7px 0',
                                fontSize: 10,
                              }}
                            >
                              <span style={{ color: C.grey }}>{fd(b.date)}</span>
                              <span style={{ fontWeight: 700 }}>
                                {b.entree} → {b.sortie}
                              </span>
                              <span style={{ fontWeight: 800, color: C.navy }}>{fmtH(h)}</span>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        </Card>
      )}
      {tab === 'pointage' && !estMagOuv && (
        <Card>
          <Bar icon="⏱" title="Pointer mes heures" color={C.amber} />
          <div style={{ padding: 13 }}>
            {/* Un départ oublié un jour passé : la journée restait « en cours »
                pour toujours, comptait 0 h, et l'ouvrier ne la voyait plus. */}
            {chantiers
              .flatMap((c) =>
                (c.pointages || [])
                  .filter((x) => x.empId === emp.id && x.entree && !x.sortie && x.date < todayISO)
                  .map((x) => ({ ...x, ch: c })),
              )
              .map((x) => {
                const cle = x.ch.id + '|' + x.date + '|' + x.entree;
                const depart = departsOublies[cle] || emp.heureFin || '17:00';
                return (
                  <div
                    key={cle}
                    role="alert"
                    style={{
                      background: '#FFF4E5',
                      border: '1px solid ' + C.amber,
                      borderRadius: 10,
                      padding: 12,
                      marginBottom: 12,
                      fontSize: 11,
                      lineHeight: 1.5,
                    }}
                  >
                    <b>
                      {trf(
                        '⚠️ Ton départ du {0} n’a pas été pointé ({1}, arrivée à {2}).',
                        dateSuisse(x.date),
                        x.ch.nom,
                        x.entree,
                      )}
                    </b>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
                      <span>À quelle heure es-tu parti ?</span>
                      <input
                        type="time"
                        aria-label="Heure de départ oubliée"
                        value={depart}
                        onChange={(e) =>
                          setDepartsOublies((p) => ({ ...p, [cle]: e.target.value }))
                        }
                        style={{ border: '1px solid ' + C.border, borderRadius: 8, padding: 6 }}
                      />
                    </div>
                    <div style={{ marginTop: 8 }}>
                      <Btn
                        label="✓ Fermer cette journée"
                        color={C.amber}
                        sm
                        onClick={() => {
                          if (!depart || depart <= x.entree) {
                            setFlash('L’heure de départ doit suivre l’arrivée (' + x.entree + ').');
                            return;
                          }
                          const autres = chantiers.flatMap((c) =>
                            (c.pointages || []).filter(
                              (y) => y.empId === emp.id && y.date === x.date && y.sortie,
                            ),
                          );
                          const pause = pauseDuSegment(autres, x.entree, depart, emp);
                          setChantiers((pp) =>
                            pp.map((c) =>
                              c.id === x.ch.id
                                ? {
                                    ...c,
                                    pointages: (c.pointages || []).map((y) =>
                                      y.empId === emp.id &&
                                      y.date === x.date &&
                                      y.entree === x.entree &&
                                      !y.sortie
                                        ? { ...y, sortie: depart, pause }
                                        : y,
                                    ),
                                  }
                                : c,
                            ),
                          );
                          setFlash('✓ Journée du ' + dateSuisse(x.date) + ' fermée à ' + depart);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            <Inp label="Chantier">
              <select
                value={chId}
                onChange={(e) => setChId(chantierChoisi(chantiers, e.target.value))}
                style={{
                  width: '100%',
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '10px',
                  fontSize: 11,
                }}
              >
                {/* Sans choix, la journée partait sur la fiche, sans chantier :
                    le patron ne la voyait sur aucun chantier. */}
                {!chantiers.some((c) => c.id === chId && c.statut === 'En cours') ? (
                  <option value="">— Choisis ton chantier —</option>
                ) : null}
                {chantiers
                  .filter((c) => c.statut === 'En cours')
                  .map((c) => (
                    <option key={c.id} value={c.id}>
                      {nomDuChantier(c, chantiers)}
                    </option>
                  ))}
              </select>
            </Inp>
            {(() => {
              const ch = chantiers.find((c) => c.id === chId);
              if (!ch) return null;
              const adr = [ch.adr, ch.npa].filter(Boolean).join(', ');
              return adr ? (
                <a
                  href={'https://maps.google.com/?q=' + encodeURIComponent(adr)}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      background: C.navyXL,
                      borderRadius: 9,
                      padding: '9px 11px',
                      marginBottom: 11,
                    }}
                  >
                    <span style={{ fontSize: 15 }}>📍</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: C.navy }}>{adr}</div>
                      <div style={{ fontSize: 8, color: C.muted }}>Toucher pour l'itinéraire</div>
                    </div>
                    <span style={{ fontSize: 13, color: C.teal }}>›</span>
                  </div>
                </a>
              ) : null;
            })()}
            <div
              style={{
                border: '1px solid ' + C.border,
                borderRadius: 10,
                padding: '11px 12px',
                marginBottom: 11,
              }}
            >
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <div style={{ flex: 1, marginRight: 10 }}>
                  <div style={{ fontSize: 10, fontWeight: 700 }}>
                    📍 Partage de ma position (GPS)
                  </div>
                  <div style={{ fontSize: 8, color: C.muted }}>
                    {emp.gps?.actif
                      ? 'Activé' + (emp.gps.at ? ' · maj ' + emp.gps.at : '')
                      : "Désactivé — ta position n'est pas partagée"}
                  </div>
                </div>
                <div
                  onClick={() => {
                    if (emp.gps?.actif) {
                      setEmployes &&
                        setEmployes((p) =>
                          p.map((x) =>
                            x.id === emp.id ? { ...x, gps: { ...(x.gps || {}), actif: false } } : x,
                          ),
                        );
                      setFlash('Partage GPS désactivé');
                    } else {
                      if (typeof navigator !== 'undefined' && navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                          (po) => {
                            const h = new Date();
                            const at =
                              String(h.getHours()).padStart(2, '0') +
                              ':' +
                              String(h.getMinutes()).padStart(2, '0');
                            const maj = h.toISOString();
                            setEmployes &&
                              setEmployes((p) =>
                                p.map((x) =>
                                  x.id === emp.id
                                    ? {
                                        ...x,
                                        gps: {
                                          actif: true,
                                          lat: po.coords.latitude,
                                          lng: po.coords.longitude,
                                          at,
                                          maj,
                                          chId,
                                        },
                                      }
                                    : x,
                                ),
                              );
                            setFlash('✓ Position partagée avec le bureau');
                          },
                          () => setFlash('⚠ Autorisation GPS refusée'),
                        );
                      } else {
                        setEmployes &&
                          setEmployes((p) =>
                            p.map((x) =>
                              x.id === emp.id ? { ...x, gps: { actif: true, at: '' } } : x,
                            ),
                          );
                        setFlash('GPS activé');
                      }
                    }
                  }}
                  style={{
                    width: 46,
                    height: 26,
                    borderRadius: 99,
                    background: emp.gps?.actif ? C.green : C.border,
                    position: 'relative',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: 2,
                      left: emp.gps?.actif ? 22 : 2,
                      width: 22,
                      height: 22,
                      borderRadius: '50%',
                      background: '#fff',
                      transition: 'left .15s',
                    }}
                  />
                </div>
              </div>
              {emp.gps?.actif &&
                (() => {
                  const ch = chantiers.find((c) => c.id === chId);
                  const d =
                    ch &&
                    ch.gps &&
                    typeof emp.gps.lat === 'number' &&
                    typeof ch.gps.lat === 'number'
                      ? distM(emp.gps.lat, emp.gps.lng, ch.gps.lat, ch.gps.lng)
                      : null;
                  if (d == null) return null;
                  const ok = d <= RAYON_CHANTIER;
                  return (
                    <div
                      style={{
                        marginTop: 9,
                        borderRadius: 8,
                        padding: '8px 10px',
                        background: ok ? C.greenL : C.redL,
                        fontSize: 9.5,
                        fontWeight: 800,
                        color: ok ? C.green : C.red,
                        textAlign: 'center',
                      }}
                    >
                      {ok
                        ? '✅ Tu es sur le chantier'
                        : "⚠ Tu n'es pas sur le chantier (" + distLisible(d) + ')'}
                    </div>
                  );
                })()}
              {emp.gps?.actif && (
                <div style={{ display: 'flex', gap: 6, marginTop: 9 }}>
                  <div style={{ flex: 1 }}>
                    <Btn
                      label="🔄 Mettre à jour ma position"
                      sm
                      ghost
                      color={C.teal}
                      full
                      onClick={() => {
                        if (typeof navigator !== 'undefined' && navigator.geolocation) {
                          navigator.geolocation.getCurrentPosition(
                            (po) => {
                              const h = new Date();
                              const at =
                                String(h.getHours()).padStart(2, '0') +
                                ':' +
                                String(h.getMinutes()).padStart(2, '0');
                              const maj = h.toISOString();
                              setEmployes &&
                                setEmployes((p) =>
                                  p.map((x) =>
                                    x.id === emp.id
                                      ? {
                                          ...x,
                                          gps: {
                                            actif: true,
                                            lat: po.coords.latitude,
                                            lng: po.coords.longitude,
                                            at,
                                            maj,
                                            chId,
                                          },
                                        }
                                      : x,
                                  ),
                                );
                              setFlash('✓ Position mise à jour');
                            },
                            () => setFlash('⚠ Autorisation GPS refusée'),
                          );
                        }
                      }}
                    />
                  </div>
                  <Btn
                    label="Annuler"
                    sm
                    ghost
                    danger
                    color={C.red}
                    onClick={() => {
                      setEmployes &&
                        setEmployes((p) =>
                          p.map((x) =>
                            x.id === emp.id ? { ...x, gps: { ...(x.gps || {}), actif: false } } : x,
                          ),
                        );
                      setFlash('Partage GPS désactivé');
                    }}
                  />
                </div>
              )}
            </div>
            {!enCours && (atelierActif || lieuxDuJour) && (
              <div role="radiogroup" aria-label={tr('Où travailles-tu aujourd’hui ?')}>
                <div style={{ fontSize: 11, fontWeight: 800, color: C.ink, marginBottom: 6 }}>
                  {tr('Où travailles-tu aujourd’hui ?')}
                </div>
                {(lieuxDuJour || [CHANTIER])
                  .flatMap((l) =>
                    l === CHANTIER
                      ? [
                          [
                            'chantier',
                            livreur ? tr('🏗 Sur un chantier (livraison)') : tr('🏗 Sur le chantier'),
                          ],
                          ...(atelierActif
                            ? [
                                ['atelier_ch', tr('🏭 À l’atelier, pour un chantier')],
                                ['atelier', tr('🏭 À l’atelier (travail général)')],
                              ]
                            : []),
                        ]
                      : [[LIEU_ECRAN[l], libelleLieu(l)]],
                  )
                  .map(([v, libelle]) => (
                    <div
                      key={v}
                      role="radio"
                      aria-checked={lieuJour === v}
                      aria-label={tr(libelle)}
                      onClick={() => setLieuJour(v)}
                      style={{
                        border: '2px solid ' + (lieuJour === v ? C.navy : C.border),
                        background: lieuJour === v ? C.navyXL : C.white,
                        borderRadius: 10,
                        padding: '9px 11px',
                        marginBottom: 6,
                        fontSize: 11.5,
                        fontWeight: 800,
                        cursor: 'pointer',
                      }}
                    >
                      {(lieuJour === v ? '● ' : '○ ') + tr(libelle)}
                    </div>
                  ))}
                {lieuJour === 'atelier_ch' && (
                  <div style={{ fontSize: 9, color: C.muted, margin: '0 0 8px' }}>
                    {tr('Tes heures comptent sur le chantier choisi plus haut.')}
                  </div>
                )}
              </div>
            )}
            {!enCours &&
            !(atelierActif && lieuJour === 'atelier') &&
            !LIEU_FICHE[lieuJour] &&
            !chantiers.some((c) => c.id === chId && c.statut === 'En cours') ? (
              <div
                role="alert"
                style={{
                  background: '#FDECEA',
                  color: C.red,
                  borderRadius: 10,
                  padding: 12,
                  fontSize: 11,
                  fontWeight: 700,
                  lineHeight: 1.5,
                  textAlign: 'center',
                }}
              >
                Choisis d&apos;abord ton chantier : tes heures s&apos;inscrivent sur le chantier où
                tu travailles.
              </div>
            ) : !enCours ? (
              <div>
                {lieuJour === 'teletravail' && !teletravailPrevu(emp, todayISO) && (
                  <Constat ton="alerte">
                    {messageDuLieu(TELETRAVAIL, null, emp, todayISO)?.texte}
                  </Constat>
                )}
                {heuresDuJour('')}
                <Btn
                  label="🟢 Pointer mon arrivée"
                  color={C.green}
                  full
                  onClick={() => {
                    const ch = chantiers.find((c) => c.id === chId);
                    const entree = arriveeRetenue();
                    // Des heures déjà pointées aujourd'hui : on ne les compte
                    // pas deux fois.
                    const deja = pointageRecouvert(
                      pointagesDuJour(chantiers, emp, todayISO),
                      entree,
                    );
                    if (deja) {
                      window.alert(
                        trf(
                          '⚠ Tu as déjà pointé aujourd’hui de {0} à {1}{2}. Ces heures sont déjà comptées : corrige ce pointage au lieu d’en ajouter un deuxième.',
                          deja.entree,
                          deja.sortie || tr('en cours'),
                          deja.chNom ? ' (' + deja.chNom + ')' : '',
                        ),
                      );
                      // L'heure choisie reste affichée, pour la corriger.
                      setHeureArrivee(entree);
                      return;
                    }
                    // Au bureau, au dépôt, en télétravail : sur la fiche,
                    // avec le contrôle du lieu.
                    if (LIEU_FICHE[lieuJour]) {
                      pointeSurLaFiche(entree, LIEU_FICHE[lieuJour]);
                      return;
                    }
                    // À l'atelier : pour un chantier, les heures restent sur
                    // ce chantier ; en général, elles vont sur la fiche.
                    const lieu = atelierActif && lieuJour !== 'chantier' ? 'ATELIER' : null;
                    const general = atelierActif && lieuJour === 'atelier';
                    ouvreLaJournee(
                      entree,
                      {
                        ...(lieu ? { lieu } : {}),
                        ...(livreur && !lieu ? { tache: tr('Livraison') } : {}),
                      },
                      !general,
                    );
                    setPointe({ entree, latE: null, lngE: null, onSiteE: null, lieu, general });
                    setFlash(
                      (lieu ? tr('✓ Arrivée à l’atelier pointée à') : tr('✓ Arrivée pointée à')) +
                        ' ' +
                        entree,
                    );
                    // À l'atelier, pas de contrôle de présence sur le chantier.
                    if (lieu) return;
                    demandeLaPosition((la, ln) => {
                      if (typeof la !== 'number') return;
                      const onS =
                        ch && ch.gps && typeof ch.gps.lat === 'number'
                          ? distM(la, ln, ch.gps.lat, ch.gps.lng) <= RAYON_CHANTIER
                          : null;
                      setPointe((p) => (p ? { ...p, latE: la, lngE: ln, onSiteE: onS } : p));
                      // La position s'inscrit tout de suite sur le pointage : elle
                      // ne vivait qu'à l'écran et se perdait si la page se rechargeait.
                      const chArrivee = ch ? ch.id : null;
                      if (chArrivee != null && setChantiers)
                        setChantiers((pp) =>
                          pp.map((c) =>
                            c.id === chArrivee
                              ? {
                                  ...c,
                                  pointages: (c.pointages || []).map((x) =>
                                    x.empId === emp.id &&
                                    x.date === todayISO &&
                                    x.entree === entree &&
                                    !x.sortie
                                      ? { ...x, latE: la, lngE: ln, onSiteEntree: onS }
                                      : x,
                                  ),
                                }
                              : c,
                          ),
                        );
                      if (onS != null) {
                        setFlash(
                          onS
                            ? '✓ Arrivée pointée — sur le chantier'
                            : '⚠ Arrivée pointée — hors du chantier',
                        );
                      }
                    });
                  }}
                />
              </div>
            ) : (
              <div>
                {heuresDuJour(enCours.entree)}
                {LIEUX_SANS_CHANTIER.includes(enCours.lieu) && !ouvertSurChantier && (
                  <>
                    {constatLieu ? (
                      <Constat ton={constatLieu.ton}>{constatLieu.texte}</Constat>
                    ) : constatDuBadge(enCours, emp) ? (
                      <div
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          color: C.grey,
                          margin: '-4px 0 9px',
                          textAlign: 'center',
                        }}
                      >
                        {marqueDuConstat(constatDuBadge(enCours, emp))}
                      </div>
                    ) : null}
                  </>
                )}
                {enCours.onSiteE != null && !LIEUX_SANS_CHANTIER.includes(enCours.lieu) && (
                  <div
                    style={{
                      fontSize: 9,
                      fontWeight: 700,
                      color: enCours.onSiteE ? C.green : C.red,
                      margin: '-4px 0 9px',
                      textAlign: 'center',
                    }}
                  >
                    {enCours.onSiteE ? '✅ Sur le chantier' : '⚠ Hors du chantier'}
                  </div>
                )}
                {(() => {
                  const atelierGeneral =
                    !ouvertSurChantier &&
                    (enCours.general ||
                      enCours.lieu === 'ATELIER' ||
                      LIEUX_SANS_CHANTIER.includes(enCours.lieu));
                  const lieuFiche =
                    !ouvertSurChantier && LIEUX_SANS_CHANTIER.includes(enCours.lieu)
                      ? enCours.lieu
                      : null;
                  const chJour = atelierGeneral
                    ? null
                    : chantiers.find(
                        (c) => c.id === (ouvertSurChantier ? ouvertSurChantier.chId : chId),
                      );
                  const aLAtelier = atelierGeneral || enCours.lieu === 'ATELIER';
                  return (
                    <div style={{ marginBottom: 11 }}>
                      {aLAtelier && (
                        <div
                          style={{ fontSize: 11, fontWeight: 800, color: C.navy, marginBottom: 6 }}
                        >
                          {lieuFiche
                            ? libelleLieu(lieuFiche)
                            : atelierGeneral
                              ? tr('🏭 À l’atelier (travail général)')
                              : tr('🏭 À l’atelier, pour ce chantier')}
                        </div>
                      )}
                      {chJour ? (
                        <div style={{ fontSize: 10, color: C.grey, marginBottom: 8 }}>
                          🏗 <b>{chJour.nom}</b>
                          {chJour.adr
                            ? ' · ' + [chJour.adr, chJour.npa].filter(Boolean).join(', ')
                            : ''}
                        </div>
                      ) : null}
                      {/* Au même endroit : le matin l'arrivée, le soir ce qui a
                          été fait (postes de l'offre, détails), puis le départ.
                          Le rapport part avec les heures. */}
                      <div
                        data-testid="travaux-du-jour"
                        style={{
                          border: '1px solid ' + C.border,
                          borderRadius: 12,
                          padding: '11px 11px 1px',
                          marginBottom: 8,
                        }}
                      >
                        <div
                          style={{ fontSize: 12, fontWeight: 800, color: C.navy, marginBottom: 4 }}
                        >
                          {tr('🔨 Ce que tu as fait aujourd’hui')}
                        </div>
                        <div style={{ fontSize: 9, color: C.muted, marginBottom: 8 }}>
                          {travauxCoches
                            ? tr(
                                'Coche avant de pointer ton départ : le rapport part avec tes heures.',
                              )
                            : tr(
                                'Écris-le avant de pointer ton départ : le rapport part avec tes heures.',
                              )}
                        </div>
                        {travauxCoches && !atelierGeneral && (
                          <ChoixTravaux
                            postes={chJour?.postes}
                            choisis={travauxRapport}
                            onChange={setTravauxRapport}
                            titre="Postes de l’offre faits aujourd’hui"
                          />
                        )}
                        {(travauxEcrits || atelierGeneral) && (
                          <Inp
                            label={
                              travauxCoches && !atelierGeneral
                                ? 'Détails (facultatif)'
                                : 'Ce que tu as fait'
                            }
                            rows={travauxCoches && !atelierGeneral ? 2 : 4}
                            value={rapport}
                            onChange={(e) => setRapport(e.target.value)}
                            placeholder={
                              travauxCoches
                                ? 'Ex. 12 m² de crépi au salon, il reste la cage d’escalier'
                                : 'Ex. Meuble de cuisine Villa Morin : montage des caissons, pose des portes'
                            }
                          />
                        )}
                      </div>
                      <Btn
                        label="📦 Matériel du dépôt"
                        color={C.teal}
                        sm
                        full
                        onClick={() => setTab('materiel')}
                      />
                    </div>
                  );
                })()}
                <Btn
                  label="🔴 Pointer mon départ"
                  color={C.red}
                  full
                  onClick={() => {
                    // Le chantier de la journée, pas celui affiché dans la liste :
                    // l'ouvrier a pu la changer depuis son arrivée.
                    const atelierGeneral =
                      !ouvertSurChantier &&
                      (enCours.general ||
                        enCours.lieu === 'ATELIER' ||
                        LIEUX_SANS_CHANTIER.includes(enCours.lieu));
                    const lieuFiche =
                      !ouvertSurChantier && LIEUX_SANS_CHANTIER.includes(enCours.lieu)
                        ? enCours.lieu
                        : null;
                    const chJourId = ouvertSurChantier
                      ? ouvertSurChantier.chId
                      : atelierGeneral
                        ? null
                        : chId;
                    const ch = chantiers.find((c) => c.id === chJourId);
                    const entree = enCours.entree;
                    const sortie = departRetenu(entree);
                    if (!sortie) return;
                    // Les chantiers déjà quittés aujourd'hui : la pause se compte
                    // une fois sur la journée, et le bilan sur la journée entière.
                    const dejaFaits = [
                      ...chantiers.flatMap((c) =>
                        (c.pointages || []).filter(
                          (x) => x.empId === emp.id && x.date === todayISO && x.sortie,
                        ),
                      ),
                      ...(emp.badges || []).filter(
                        (b) => b.date === todayISO && b.sortie && b.chId == null,
                      ),
                    ];
                    const recouvert = pointageRecouvert(dejaFaits, entree, sortie);
                    if (recouvert) {
                      window.alert(
                        trf(
                          '⚠ Ces heures ({0} → {1}) recouvrent un pointage déjà fait aujourd’hui ({2} → {3}). Corrige l’heure d’arrivée ou de départ.',
                          entree,
                          sortie,
                          recouvert.entree,
                          recouvert.sortie,
                        ),
                      );
                      return;
                    }
                    const pause = pauseDuSegment(dejaFaits, entree, sortie, emp);
                    // L'heure d'abord, comme a l'arrivee : la position peut ne
                    // jamais venir, et l'ouvrier ne doit pas rester devant un
                    // bouton qui ne repond pas.
                    fermeLaJournee(sortie, {
                      pause,
                      // Après un rechargement, la position est sur le pointage.
                      onSiteEntree: enCours.onSiteE ?? enCours.onSiteEntree ?? null,
                      latE: enCours.latE,
                      lngE: enCours.lngE,
                      // À l'atelier en général, ce qui a été fait reste sur le
                      // pointage : aucun chantier ne reçoit de rapport.
                      ...(atelierGeneral && rapport.trim() ? { tache: rapport.trim() } : {}),
                    });
                    if (atelierGeneral) setRapport('');
                    setPointe(null);
                    setConstatLieu(null);
                    // Au bureau ou au dépôt : le même contrôle au départ.
                    if (lieuFiche === BUREAU || lieuFiche === DEPOT) {
                      demandeLaPosition((la, ln) => {
                        const { surPlace } = controleLieu(lieuFiche, la, ln, lieuxSociete);
                        if (surPlace == null || !setEmployes) return;
                        setEmployes((p) =>
                          p.map((x) =>
                            x.id === emp.id
                              ? {
                                  ...x,
                                  badges: (x.badges || []).map((b) =>
                                    b.chId == null && b.date === todayISO && b.sortie === sortie
                                      ? { ...b, onSiteSortie: surPlace }
                                      : b,
                                  ),
                                }
                              : x,
                          ),
                        );
                      });
                    }
                    // Les travaux du jour, cochés ici avant de partir : le
                    // rapport part avec les heures, sans autre écran.
                    const avecRapport =
                      !!chJourId && (travauxRapport.length > 0 || !!rapport.trim());
                    if (avecRapport) {
                      ajouteRapport(chJourId, {
                        hd: entree,
                        hf: sortie,
                        heures: hours(entree, sortie, pause),
                      });
                    }
                    const bilan = phraseDuDepart(entree, sortie, emp, dejaFaits);
                    setFlash(
                      '✓ Journée enregistrée (' +
                        entree +
                        ' → ' +
                        sortie +
                        ')' +
                        (bilan ? ' · ' + bilan : '') +
                        (avecRapport ? ' · ' + tr('rapport envoyé') : ''),
                    );
                    demandeLaPosition((la, ln) => {
                      if (typeof la !== 'number') return;
                      const onSortie =
                        ch && ch.gps && typeof ch.gps.lat === 'number'
                          ? distM(la, ln, ch.gps.lat, ch.gps.lng) <= RAYON_CHANTIER
                          : null;
                      if (onSortie == null || !setChantiers) return;
                      setChantiers((p) =>
                        p.map((c) =>
                          c.id === chJourId
                            ? {
                                ...c,
                                pointages: (c.pointages || []).map((x) =>
                                  x.empId === emp.id && x.date === todayISO && x.sortie === sortie
                                    ? { ...x, onSiteSortie: onSortie }
                                    : x,
                                ),
                              }
                            : c,
                        ),
                      );
                    });
                  }}
                />
              </div>
            )}
            <div
              style={{
                marginTop: 14,
                fontSize: 9,
                fontWeight: 700,
                color: C.muted,
                textTransform: 'uppercase',
              }}
            >
              Mes derniers pointages
            </div>
            {mesPointages
              .slice(-5)
              .reverse()
              .map((p) => {
                const hh = hours(p.entree, p.sortie, p.pause);
                // Des heures pointées deux fois le même jour : signalées, et
                // celles d'aujourd'hui se retirent d'un geste.
                const double = !!pointageRecouvert(
                  pointagesDuJour(chantiers, emp, p.date),
                  p.entree,
                  p.sortie || undefined,
                  p.id,
                );
                const retirable = p.date === todayISO && !!p.sortie && setChantiers;
                return (
                  <div
                    key={p.id}
                    data-testid="mon-pointage"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 6,
                      padding: '8px 0',
                      borderBottom: '1px solid ' + C.border,
                      fontSize: 9.5,
                    }}
                  >
                    <span style={{ flex: 1, minWidth: 0 }}>
                      {jourEnLettres(p.date)} · {p.chNom}
                      <span style={{ display: 'block', color: C.muted, fontSize: 9 }}>
                        {(p.entree || '—') + ' → ' + (p.sortie || tr('en cours'))}
                      </span>
                      {double && (
                        <span
                          style={{ display: 'block', color: C.red, fontSize: 9, fontWeight: 800 }}
                        >
                          {tr('⚠ Heures pointées deux fois ce jour-là')}
                        </span>
                      )}
                    </span>
                    {retirable && (
                      <button
                        type="button"
                        aria-label={trf('Retirer le pointage {0} → {1}', p.entree, p.sortie)}
                        onClick={() => {
                          if (
                            !window.confirm(
                              trf(
                                'Retirer le pointage de {0} à {1} ? Les heures ne compteront plus.',
                                p.entree,
                                p.sortie,
                              ),
                            )
                          )
                            return;
                          setChantiers((pp) =>
                            pp.map((c) => ({
                              ...c,
                              pointages: (c.pointages || []).filter((x) => x.id !== p.id),
                            })),
                          );
                          setFlash(tr('✓ Pointage retiré'));
                        }}
                        style={{
                          border: '1px solid ' + C.border,
                          background: C.white,
                          color: C.red,
                          borderRadius: 8,
                          padding: '4px 7px',
                          fontSize: 11,
                          cursor: 'pointer',
                        }}
                      >
                        🗑
                      </button>
                    )}
                    <span>
                      <b>{p.sortie ? fmtH(hh) : '…'}</b>
                      {p.sortie && (
                        <span
                          style={{
                            marginLeft: 6,
                            fontWeight: 700,
                            color:
                              ecartDuJour(hh, emp) > 0
                                ? C.green
                                : ecartDuJour(hh, emp) < 0
                                  ? C.amber
                                  : C.muted,
                          }}
                        >
                          {fmtEcart(ecartDuJour(hh, emp))}
                        </span>
                      )}
                    </span>
                  </div>
                );
              })}
          </div>
        </Card>
      )}

      {tab === 'photos' && (
        <Card>
          <Bar
            icon="📷"
            title="Photos du chantier"
            color={C.teal}
            sub="Le bureau choisit celles que le client verra"
          />
          <div style={{ padding: 13 }}>
            {/* Sans chantier ouvert (souvent au magasin), une liste vide et un
                bouton photo qui ne pouvait que refuser : on le dit d'emblée. */}
            {!chantiers.some((c) => c.statut === 'En cours') ? (
              <div style={{ textAlign: 'center', padding: 18, color: C.muted, fontSize: 10 }}>
                Aucun chantier en cours : la photo se rattache à un chantier ouvert par le bureau.
              </div>
            ) : (
              <>
                <Inp label="Chantier">
                  <select
                    value={chId}
                    onChange={(e) => setChId(chantierChoisi(chantiers, e.target.value))}
                    style={{
                      width: '100%',
                      border: '1px solid ' + C.border,
                      borderRadius: 9,
                      padding: '10px',
                      fontSize: 11,
                    }}
                  >
                    {chantiers
                      .filter((c) => c.statut === 'En cours')
                      .map((c) => (
                        <option key={c.id} value={c.id}>
                          {nomDuChantier(c, chantiers)}
                        </option>
                      ))}
                  </select>
                </Inp>
                <div
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    color: C.muted,
                    marginBottom: 5,
                    textTransform: 'uppercase',
                  }}
                >
                  Étape
                </div>
                <div style={{ display: 'flex', gap: 5, marginBottom: 9 }}>
                  {[
                    ['avant', '🧱 Avant'],
                    ['pendant', '🔨 Pendant'],
                    ['apres', '✨ Après'],
                    ['probleme', '⚠ Problème'],
                  ].map(([cat, lb]) => (
                    <div
                      key={cat}
                      onClick={() => setPhotoCat(cat)}
                      style={{
                        flex: 1,
                        textAlign: 'center',
                        padding: '7px 3px',
                        borderRadius: 8,
                        fontSize: 8.5,
                        fontWeight: 700,
                        cursor: 'pointer',
                        border: '1px solid ' + (photoCat === cat ? C.teal : C.border),
                        background: photoCat === cat ? C.teal : C.white,
                        color: photoCat === cat ? '#fff' : C.grey,
                      }}
                    >
                      {lb}
                    </div>
                  ))}
                </div>
                <Inp
                  label="Travail photographié (poste)"
                  value={photoPoste}
                  onChange={(e) => setPhotoPoste(e.target.value)}
                  placeholder="Ex. Étanchéité, carrelage, électricité…"
                  list="postes-du-chantier"
                />
                <datalist id="postes-du-chantier">
                  {(chantiers.find((c) => c.id === chId)?.postes || []).map((p) => (
                    <option key={p} value={p} />
                  ))}
                </datalist>
                <Inp
                  label="Légende de la photo (facultatif)"
                  value={photoNote}
                  onChange={(e) => setPhotoNote(e.target.value)}
                  placeholder="Ex. Mur nord du salon, avant les joints"
                />
                <PhotoBtn
                  label={photoEnvoi ? 'Envoi…' : '📷 Prendre une photo'}
                  color={C.teal}
                  full
                  onPhoto={async (apercu, fichier) => {
                    // La photo s'envoie avec son fichier, a son propre point
                    // d'entree, comme depuis la fiche chantier. Poussee dans
                    // l'agregat en base64, elle n'etait jamais enregistree : le
                    // serveur ignore une photo sans identifiant, et elle
                    // disparaissait au rechargement.
                    if (photoEnvoi) return;
                    // Sans chantier en cours (tous reçus, ou aucun ouvert), la
                    // liste est vide et la photo partait vers « /chantiers//photos » :
                    // le serveur répondait par un « HTTP 405 » que personne ne comprend.
                    if (!chantiers.some((c) => c.id === chId && c.statut === 'En cours')) {
                      setPhotoErr(
                        'Aucun chantier en cours : la photo doit être rattachée à un chantier ouvert par le bureau.',
                      );
                      return;
                    }
                    const note = photoNote.trim();
                    const em =
                      { avant: '🧱', pendant: '🔨', apres: '✨', probleme: '⚠' }[photoCat] || '📷';
                    const description = {
                      cat: photoCat,
                      emoji: em,
                      label: (note || 'Photo') + ' — ' + today(),
                      note,
                      date: today(),
                      h: heureCourante(),
                      auteur: nomComplet(emp),
                      poste: photoPoste.trim(),
                      // Le patron, le technicien ou la secrétaire choisit les
                      // photos que voit le client : à la prise, elle reste interne.
                      partageClient: false,
                    };
                    setPhotoEnvoi(true);
                    setPhotoErr('');
                    try {
                      const photo = await photosApi.depose(chId, fichier, {
                        categorie: photoCat,
                        libelle: description.label,
                        // La fiche chantier et la page du client affichent la note :
                        // sans elle, la photo de l'ouvrier s'y appelait « Photo ».
                        note,
                        auteur: nomComplet(emp),
                        poste: photoPoste.trim() || undefined,
                        partageClient: false,
                      });
                      setChantiers((p) =>
                        p.map((c) =>
                          c.id === chId
                            ? {
                                ...c,
                                photos: [
                                  ...(c.photos || []),
                                  {
                                    ...description,
                                    id: photo.id,
                                    src: photo.image ? adresseApi(photo.image) : apercu,
                                  },
                                ],
                                messages: [
                                  ...(c.messages || []),
                                  {
                                    id: uid(),
                                    de: 'ouvrier',
                                    contenu: '📷 Photo ajoutée' + (note ? ' : ' + note : ''),
                                    date: today().slice(0, 5),
                                    h: '',
                                    lu: false,
                                  },
                                ],
                              }
                            : c,
                        ),
                      );
                      setPhotoNote('');
                      setFlash('✓ Photo ajoutée au chantier');
                    } catch (e) {
                      setPhotoErr(e?.message || "La photo n'a pas pu être envoyée. Réessaie.");
                    } finally {
                      setPhotoEnvoi(false);
                    }
                  }}
                />
                {photoErr && (
                  <div role="alert" style={{ fontSize: 10, color: C.red, marginTop: 6 }}>
                    {photoErr}
                  </div>
                )}
                {(() => {
                  const ch = chantiers.find((c) => c.id === chId);
                  const ph = (ch?.photos || []).filter((p) => p.src);
                  if (!ph.length)
                    return (
                      <div
                        style={{ textAlign: 'center', padding: 18, color: C.muted, fontSize: 9.5 }}
                      >
                        Aucune photo sur ce chantier.
                      </div>
                    );
                  return (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: 8,
                        marginTop: 11,
                      }}
                    >
                      {ph
                        .slice()
                        .reverse()
                        .map((p) => (
                          <div
                            key={p.id}
                            style={{
                              borderRadius: 10,
                              overflow: 'hidden',
                              border: '1px solid ' + C.border,
                            }}
                          >
                            <img
                              src={p.src}
                              alt=""
                              style={{ width: '100%', height: 90, objectFit: 'cover' }}
                            />
                            <div style={{ padding: '6px 8px' }}>
                              <div style={{ fontSize: 8.5, fontWeight: 700 }}>
                                {p.emoji} {p.note || p.label}
                              </div>
                              <div style={{ fontSize: 7.5, color: C.muted }}>
                                {p.date} · {p.auteur}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  );
                })()}
              </>
            )}
          </div>
        </Card>
      )}

      {tab === 'formation' &&
        (() => {
          const f = emp.formation || {};
          const du = formationDu(f);
          const has = !!(f.nom || +f.cout > 0);
          return (
            <>
              {/* Demander un cours, suivre la réponse, signer la convention. */}
              <MesFormations titulaire={titulaire} />
              <Card>
                <Bar icon="🎓" title="Ma formation" color={C.purple} sub="Accord avec la société" />
                <div style={{ padding: 13 }}>
                  {!has ? (
                    <div
                      style={{
                        fontSize: 11,
                        color: C.muted,
                        lineHeight: 1.6,
                        textAlign: 'center',
                        padding: '14px 8px',
                      }}
                    >
                      Aucun accord de formation pour l'instant.
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          border: '1px solid ' + C.border,
                          borderRadius: 10,
                          overflow: 'hidden',
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '10px 13px',
                            fontSize: 11,
                            background: '#fafbfc',
                            borderBottom: '1px solid ' + C.border,
                          }}
                        >
                          <span>Formation</span>
                          <b>{f.nom || '—'}</b>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '10px 13px',
                            fontSize: 11,
                            borderBottom: '1px solid ' + C.border,
                          }}
                        >
                          <span>Payée par la société</span>
                          <b>
                            {DEVISE} {fmt(+f.cout || 0)}
                          </b>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '10px 13px',
                            fontSize: 11,
                          }}
                        >
                          <span>Engagement</span>
                          <b>{f.engagementMois || 0} mois</b>
                        </div>
                      </div>
                      <div
                        style={{
                          background: 'linear-gradient(135deg,' + C.amber + ',#7a3d0a)',
                          borderRadius: 12,
                          padding: '16px',
                          color: '#fff',
                          marginBottom: 12,
                        }}
                      >
                        <div
                          style={{
                            fontSize: 9,
                            color: 'rgba(255,255,255,.8)',
                            textTransform: 'uppercase',
                          }}
                        >
                          Si je pars maintenant, je rembourse
                        </div>
                        <div style={{ fontSize: 26, fontWeight: 900, margin: '3px 0' }}>
                          {DEVISE} {fmt(du)}
                        </div>
                        <div style={{ fontSize: 9, color: 'rgba(255,255,255,.85)' }}>
                          Ce montant baisse chaque mois. Plus rien après la fin de l'engagement.
                        </div>
                      </div>
                      {du === 0 && (
                        <div
                          style={{
                            background: C.greenL,
                            border: '1px solid #bfe6cf',
                            borderRadius: 10,
                            padding: '10px 12px',
                            fontSize: 10,
                            color: C.green,
                            fontWeight: 700,
                          }}
                        >
                          ✅ Tu n'as plus rien à rembourser.
                        </div>
                      )}
                      {f.texte && (
                        <div
                          style={{
                            marginTop: 12,
                            fontSize: 10,
                            color: C.grey,
                            lineHeight: 1.6,
                            whiteSpace: 'pre-wrap',
                          }}
                        >
                          <b style={{ color: C.navy }}>Conditions de la convention</b>
                          <br />
                          {f.texte}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Card>
            </>
          );
        })()}
      {tab === 'signature' &&
        (() => {
          const sig = emp.signature;
          const setSig = (d) =>
            setEmployes((p) => p.map((x) => (x.id === emp.id ? { ...x, signature: d } : x)));
          return (
            <Card>
              <Bar
                icon="✍️"
                title="Ma signature"
                color={C.purple}
                sub="Ta signature, réutilisée sur tes documents"
              />
              <div style={{ padding: 13 }}>
                {sig ? (
                  <div>
                    <div style={{ fontSize: 9, color: C.green, marginBottom: 7, fontWeight: 800 }}>
                      ✅ Signature enregistrée
                    </div>
                    <img
                      src={sig}
                      alt="signature"
                      style={{
                        height: 70,
                        border: '1px solid ' + C.border,
                        borderRadius: 10,
                        background: '#fff',
                        display: 'block',
                        marginBottom: 10,
                        maxWidth: '100%',
                      }}
                    />
                    <Btn
                      label="✍ Refaire ma signature"
                      sm
                      ghost
                      color={C.grey}
                      onClick={() => setSig('')}
                    />
                  </div>
                ) : (
                  <div>
                    <div
                      style={{ fontSize: 10, color: C.grey, lineHeight: 1.55, marginBottom: 10 }}
                    >
                      Signe une fois ci-dessous. Ta signature sera <b>réutilisée automatiquement</b>{' '}
                      quand tu signes un document (résiliation, convention de formation…).
                    </div>
                    <SignaturePad aValider onSign={setSig} />
                  </div>
                )}
                <div style={{ fontSize: 8, color: C.muted, marginTop: 12, lineHeight: 1.5 }}>
                  🔒 Ta signature reste dans ton espace. Tu la réutilises d'un geste sur tes
                  documents.
                </div>
              </div>
            </Card>
          );
        })()}
      {tab === 'salaire' &&
        (() => {
          const pts = pointagesDuMois;
          const totalH = pts.reduce(
            (s, p) => (p.type === 'absence' ? s : s + hours(p.entree, p.sortie, p.pause)),
            0,
          );
          const txH = emp.txH || 0;
          const auForfait = totalH <= 0 || txH <= 0;
          const salHeures = auForfait ? emp.salBase || 0 : totalH * txH;
          // Payé à l'heure, son indemnité de vacances fait partie du brut et
          // supporte les cotisations, comme sur sa fiche officielle.
          const indemVac =
            !auForfait && +emp.tauxVac > 0
              ? Math.round(salHeures * ((+emp.tauxVac || 0) / 100) * 100) / 100
              : 0;
          const brut = salHeures + indemVac;
          // Estimation selon son taux LPP, ses assujettissements et les taux
          // de l'entreprise, ceux de sa fiche officielle : elle prélevait la
          // LPP à 5 % à tout le monde, et l'AVS au taux légal. Hors de Suisse,
          // les cotisations du pays.
          const rMois = retenuesSalariales(
            brut,
            emp,
            emp.tauxRetenues,
            lignesDuPays(soc, new Date().getFullYear(), emp.tauxRetenues?.canton),
          );
          const { soumis, taux, lpp, dAvs, dAc, dAanp, dIjm, dLpp, dCanton } = rMois;
          const ded = dAvs + dAc + dAanp + dIjm + dLpp + dCanton;
          const lignesRetenues = rMois.pays
            ? rMois.detail.map((d) => [d.libelle + ' (' + tauxEcrit(d.taux) + '%)', d.montant])
            : [
                soumis.avs && ['AVS / AI / APG (' + tauxEcrit(taux.avs) + '%)', dAvs],
                soumis.ac && ['Chômage AC (' + tauxEcrit(taux.ac) + '%)', dAc],
                soumis.aanp && ['Accident AANP (' + tauxEcrit(taux.aanp) + '%)', dAanp],
                dIjm > 0 && ['IJM maladie (' + tauxEcrit(taux.ijm) + '%)', dIjm],
                dCanton > 0 && [
                  'Autres cotisations sociales (' + tauxEcrit(taux.canton) + '%)',
                  dCanton,
                ],
                soumis.lpp && ['LPP 2e pilier (' + lpp + '%)', dLpp],
              ].filter(Boolean);
          const joursRepas = [
            ...new Set(pts.filter((p) => p.type !== 'absence').map((p) => p.date)),
          ].length;
          const indemRepas = Math.round((+emp.fraisRepas || 0) * joursRepas * 100) / 100;
          const net = brut - ded + indemRepas;
          const periode = new Date().toLocaleDateString(localeDates(), {
            month: 'long',
            year: 'numeric',
          });
          return (
            <Card>
              <Bar icon="💰" title="Mon salaire" color={C.green} sub={'Période : ' + periode} />
              <div style={{ padding: 13 }}>
                <MesFichesDeSalaire fiches={fichesPaie} />
                <div
                  style={{
                    background: 'linear-gradient(135deg,' + C.green + ',#0A5C32)',
                    borderRadius: 12,
                    padding: '18px 16px',
                    textAlign: 'center',
                    marginBottom: 14,
                  }}
                >
                  <div
                    style={{
                      fontSize: 9.5,
                      color: 'rgba(255,255,255,.75)',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    Salaire net estimé
                  </div>
                  <div style={{ fontSize: 30, fontWeight: 900, color: '#fff', margin: '3px 0' }}>
                    {DEVISE} {fmt(net)}
                  </div>
                  <div style={{ fontSize: 9, color: 'rgba(255,255,255,.65)' }}>
                    versé en fin de mois
                  </div>
                </div>

                <div
                  style={{
                    fontSize: 9,
                    fontWeight: 800,
                    color: C.muted,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    marginBottom: 5,
                  }}
                >
                  Détail du calcul
                </div>
                <div
                  style={{
                    border: '1px solid ' + C.border,
                    borderRadius: 10,
                    overflow: 'hidden',
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '10px 13px',
                      fontSize: 11,
                      background: '#fafbfc',
                    }}
                  >
                    <span>Salaire brut</span>
                    <b>
                      {DEVISE} {fmt(brut)}
                    </b>
                  </div>
                  <div style={{ padding: '8px 13px', borderTop: '1px solid ' + C.border }}>
                    {lignesRetenues.map(([libelle, montant]) => (
                      <div
                        key={libelle}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          fontSize: 10,
                          color: C.grey,
                          padding: '3px 0',
                        }}
                      >
                        <span>{libelle}</span>
                        <span style={{ color: C.red }}>
                          − {DEVISE} {fmt(montant)}
                        </span>
                      </div>
                    ))}
                  </div>
                  {indemRepas > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '9px 13px',
                        fontSize: 11,
                        borderTop: '1px solid ' + C.border,
                        background: C.tealL,
                      }}
                    >
                      <span>🍽 Indemnité repas ({joursRepas} j)</span>
                      <span style={{ color: C.teal, fontWeight: 800 }}>
                        + {DEVISE} {fmt(indemRepas)}
                      </span>
                    </div>
                  )}
                  {indemVac > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '9px 13px',
                        fontSize: 11,
                        borderTop: '1px solid ' + C.border,
                        background: C.tealL,
                      }}
                    >
                      <span>
                        {`🌴 dont indemnité vacances (${emp.tauxVac || 0}%), comprise dans le brut`}
                      </span>
                      <span style={{ color: C.teal, fontWeight: 800 }}>
                        {DEVISE} {fmt(indemVac)}
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '10px 13px',
                      fontSize: 11.5,
                      fontWeight: 800,
                      borderTop: '2px solid ' + C.navy,
                      background: C.greenL,
                    }}
                  >
                    <span>Net à payer</span>
                    <span style={{ color: C.green }}>
                      {DEVISE} {fmt(net)}
                    </span>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <div
                    style={{
                      flex: 1,
                      background: C.navyXL,
                      borderRadius: 9,
                      padding: '9px 11px',
                      textAlign: 'center',
                    }}
                  >
                    <div style={{ fontSize: 8, color: C.muted, textTransform: 'uppercase' }}>
                      Heures pointées
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 900, color: C.navy }}>
                      {fmtH(totalH)}
                    </div>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      background: C.navyXL,
                      borderRadius: 9,
                      padding: '9px 11px',
                      textAlign: 'center',
                    }}
                  >
                    <div style={{ fontSize: 8, color: C.muted, textTransform: 'uppercase' }}>
                      Taux horaire
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 900, color: C.navy }}>
                      {DEVISE} {fmt(emp.txH || 0)}
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <Btn
                    label="📅 Relevé mensuel complet (A4)"
                    color={C.teal}
                    full
                    onClick={() => setShowMensuel(true)}
                  />
                  <Btn
                    label="🧾 Estimation du mois en cours (A4)"
                    color={C.green}
                    full
                    onClick={() => setShowFiche(true)}
                  />
                  <Btn
                    label="⏱ Mon relevé d'heures (A4)"
                    color={C.navy}
                    full
                    onClick={() => setShowReleve(true)}
                  />
                </div>
                {(() => {
                  const pc = chantiers
                    .map((c) => {
                      const pts = (c.pointages || []).filter((p) => p.empId === emp.id);
                      const rs = (c.rapports || []).filter((r) =>
                        r.empId != null ? r.empId === emp.id : r.empNom === emp.nom,
                      );
                      const norm = (d) => {
                        d = (d || '') + '';
                        if (d.includes('-')) {
                          const z = d.split('-');
                          return {
                            k: z[0] + (z[1] || '').padStart(2, '0') + (z[2] || '').padStart(2, '0'),
                            l: (z[2] || '') + '.' + (z[1] || '') + '.' + z[0],
                          };
                        }
                        const p = d.split('.');
                        if (p.length >= 3)
                          return {
                            k: p[2] + p[1].padStart(2, '0') + p[0].padStart(2, '0'),
                            l: p[0].padStart(2, '0') + '.' + p[1].padStart(2, '0') + '.' + p[2],
                          };
                        return { k: d, l: d };
                      };
                      const bd = {};
                      pts.forEach((p) => {
                        const z = norm(p.date),
                          k = z.k;
                        bd[k] = bd[k] || {
                          date: z.l,
                          k: z.k,
                          h: 0,
                          e: '',
                          s: '',
                          note: '',
                          meteo: '',
                        };
                        bd[k].h += hours(p.entree, p.sortie, p.pause);
                        if (p.entree) bd[k].e = p.entree;
                        if (p.sortie) bd[k].s = p.sortie;
                      });
                      rs.forEach((r) => {
                        const z = norm(r.date),
                          k = z.k;
                        bd[k] = bd[k] || {
                          date: z.l,
                          k: z.k,
                          h: r.heures || 0,
                          e: r.hd || '',
                          s: r.hf || '',
                          note: '',
                          meteo: '',
                        };
                        bd[k].note = r.contenu || bd[k].note;
                        bd[k].meteo = r.meteo || bd[k].meteo;
                        if (!bd[k].h && r.heures) bd[k].h = r.heures;
                      });
                      const days = Object.values(bd).sort((a, b) =>
                        (b.k || '').localeCompare(a.k || ''),
                      );
                      return {
                        id: c.id,
                        nom: c.nom,
                        adr: [c.adr, c.npa].filter(Boolean).join(', '),
                        h: totalDesJours(days),
                        n: pts.length + rs.length,
                        days,
                      };
                    })
                    .filter((x) => x.n > 0);
                  if (!pc.length) return null;
                  return (
                    <div style={{ marginTop: 14 }}>
                      <div
                        style={{
                          fontSize: 9,
                          fontWeight: 800,
                          color: C.muted,
                          textTransform: 'uppercase',
                          marginBottom: 7,
                        }}
                      >
                        🏗 Mes chantiers — jour par jour
                      </div>
                      {pc.map((x, i) => (
                        <div
                          key={i}
                          style={{
                            padding: '9px 11px',
                            border: '1px solid ' + C.border,
                            borderRadius: 9,
                            marginBottom: 7,
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'flex-start',
                            }}
                          >
                            <div style={{ flex: 1, marginRight: 10 }}>
                              <div style={{ fontSize: 10, fontWeight: 800 }}>{x.nom}</div>
                              <div style={{ fontSize: 8.5, color: C.muted }}>📍 {x.adr || '—'}</div>
                            </div>
                            <div style={{ fontSize: 12, fontWeight: 900, color: C.teal }}>
                              {fmtH(x.h)}
                            </div>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            {x.days.map((d, j) => (
                              <div
                                key={j}
                                style={{
                                  borderLeft: '2px solid ' + C.border,
                                  paddingLeft: 8,
                                  marginBottom: 5,
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: 9,
                                  }}
                                >
                                  <span style={{ fontWeight: 700, color: C.navy }}>
                                    📅 {d.date}
                                    {d.e ? ' · ' + d.e + (d.s ? '→' + d.s : '') : ''}
                                  </span>
                                  <b style={{ color: C.teal }}>{fmtH(d.h)}</b>
                                </div>
                                {d.note && (
                                  <div
                                    style={{
                                      fontSize: 8,
                                      color: C.grey,
                                      fontStyle: 'italic',
                                      marginTop: 1,
                                    }}
                                  >
                                    📝 {d.note}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                          <div style={{ display: 'flex', gap: 6, marginTop: 7 }}>
                            <input
                              value={noteDraft[x.id] || ''}
                              onChange={(e) =>
                                setNoteDraft((d) => ({ ...d, [x.id]: e.target.value }))
                              }
                              placeholder="Ce que j'ai fait aujourd'hui…"
                              style={{
                                flex: 1,
                                border: '1px solid ' + C.border,
                                borderRadius: 8,
                                padding: '7px 9px',
                                fontSize: 10,
                              }}
                            />
                            <Btn
                              label="✓"
                              sm
                              color={C.teal}
                              disabled={!(noteDraft[x.id] || '').trim()}
                              onClick={() => {
                                const t = (noteDraft[x.id] || '').trim();
                                if (!t) return;
                                setChantiers((p) =>
                                  p.map((c) =>
                                    c.id === x.id
                                      ? {
                                          ...c,
                                          rapports: [
                                            ...(c.rapports || []),
                                            {
                                              id: uid(),
                                              empNom: emp.nom,
                                              date: today(),
                                              contenu: t,
                                              meteo: '',
                                              materiel: '',
                                              heures: 0,
                                            },
                                          ],
                                        }
                                      : c,
                                  ),
                                );
                                setNoteDraft((d) => ({ ...d, [x.id]: '' }));
                                setFlash && setFlash('✓ Note du jour enregistrée');
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            </Card>
          );
        })()}

      {tab === 'vacances' && (
        <MesConges
          emp={emp}
          conges={conges}
          setConges={setConges}
          setFlash={setFlash}
          validesDOffice={modeTerrain}
        />
      )}
      {tab === 'absence' && (
        <MesConges
          absence
          emp={emp}
          conges={conges}
          setConges={setConges}
          setFlash={setFlash}
          validesDOffice={modeTerrain}
        />
      )}
      {tab === 'rdv' &&
        (() => {
          // Les affectations du patron, sur sept jours : l'ouvrier ne voyait
          // que le chantier du jour, et ne savait pas où il travaillait demain.
          const jours = Array.from({ length: 7 }, (_, i) => {
            const d = new Date();
            d.setDate(d.getDate() + i);
            return (
              d.getFullYear() +
              '-' +
              String(d.getMonth() + 1).padStart(2, '0') +
              '-' +
              String(d.getDate()).padStart(2, '0')
            );
          });
          const semaine = jours
            .map((jour) => ({
              jour,
              ou: (chantiers || []).filter((c) =>
                (c.planif || []).some((x) => x.empId === empId && x.date === jour),
              ),
            }))
            .filter((j) => j.ou.length > 0);
          if (!semaine.length) return null;
          return (
            <Card style={{ marginBottom: 11 }}>
              <Bar icon="🗓" title={tr('Ma semaine')} color={C.teal} />
              <div style={{ padding: '6px 13px 10px' }} data-testid="ma-semaine">
                {semaine.map(({ jour, ou }) => (
                  <div
                    key={jour}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 10,
                      padding: '7px 0',
                      borderBottom: '1px solid ' + C.border,
                      fontSize: 11,
                    }}
                  >
                    <span style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                      {new Date(jour + 'T00:00:00').toLocaleDateString(localeDates(), {
                        weekday: 'short',
                        day: '2-digit',
                        month: '2-digit',
                      })}
                    </span>
                    <span style={{ textAlign: 'right', color: C.ink }}>
                      {ou.map((c) => c.nom).join(' · ')}
                    </span>
                  </div>
                ))}
              </div>
            </Card>
          );
        })()}
      {tab === 'rdv' && (
        <Card>
          <Bar
            icon="📅"
            title="Mes rendez-vous"
            color={C.navy}
            sub="Convocations transmises par le bureau"
          />
          <div style={{ padding: 13 }}>
            {(() => {
              const mine = (rdv || [])
                .filter((r) => (r.employeIds || []).includes(empId))
                .sort((a, b) => (a.date + a.heure).localeCompare(b.date + b.heure));
              if (!mine.length)
                return (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: 24,
                      color: C.muted,
                      fontSize: 9.5,
                      lineHeight: 1.5,
                    }}
                  >
                    Aucun rendez-vous pour toi pour l'instant.
                  </div>
                );
              return mine.map((r) => {
                const c = (chantiers || []).find((x) => x.id === r.chantierId);
                return (
                  <Card key={r.id} style={{ marginBottom: 8 }}>
                    <div
                      style={{
                        padding: '11px 13px',
                        display: 'flex',
                        gap: 12,
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          flexShrink: 0,
                          background: C.navyXL,
                          borderRadius: 9,
                          padding: '7px 9px',
                        }}
                      >
                        <div style={{ fontSize: 8, color: C.muted }}>{dateSuisse(r.date)}</div>
                        <div style={{ fontSize: 13, fontWeight: 900, color: C.navy }}>
                          {r.heure}
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 10.5, fontWeight: 700 }}>{r.objet}</div>
                        <div style={{ fontSize: 8.5, color: C.muted }}>
                          {r.heureFin ? '⏱ ' + r.heure + '–' + r.heureFin + ' · ' : ''}
                          {c ? '🏗 ' + c.nom : r.lieuNom ? '🏠 ' + r.lieuNom : ''}
                          {r.lieu ? ' · 📍 ' + r.lieu : ''}
                          {r.avecQui ? ' · 👤 ' + r.avecQui : ''}
                        </div>
                        {r.noteEquipe && (
                          <div style={{ fontSize: 9, color: C.ink, marginTop: 3 }}>
                            📝 {r.noteEquipe}
                          </div>
                        )}
                      </div>
                    </div>
                    {titulaire &&
                      (() => {
                        // Sa réponse : la plus récente de sa cloche, sinon celle
                        // relue avec le rendez-vous.
                        const sien = (signaux?.liste || []).find(
                          (x) => x.referenceId === r.id && /^RDV(_MODIFIE|_RAPPEL)?$/.test(x.type),
                        );
                        const signalId = sien?.id ?? r.maReponse?.signalId;
                        const reponse = sien?.reponse ?? r.maReponse?.reponse;
                        if (!signalId || !signaux?.repond) return null;
                        const bouton = (valeur, libelle, couleur) => (
                          <button
                            type="button"
                            onClick={() => {
                              const texte =
                                valeur === 'ABSENT'
                                  ? window.prompt(tr('Message au bureau (facultatif)')) || ''
                                  : undefined;
                              signaux.repond(signalId, valeur, texte).catch(() => {});
                            }}
                            style={{
                              flex: 1,
                              minHeight: 36,
                              borderRadius: 8,
                              border: '1.5px solid ' + couleur,
                              background: reponse === valeur ? couleur : C.white,
                              color: reponse === valeur ? C.white : couleur,
                              fontSize: 10.5,
                              fontWeight: 800,
                              cursor: 'pointer',
                            }}
                          >
                            {tr(libelle)}
                          </button>
                        );
                        return (
                          <div style={{ display: 'flex', gap: 8, padding: '0 13px 11px' }}>
                            {bouton('ABSENT', 'Je ne peux pas', C.red)}
                            {bouton('PRESENT', '✓ Je serai là', C.green)}
                          </div>
                        );
                      })()}
                  </Card>
                );
              });
            })()}
          </div>
        </Card>
      )}
      {(tab === 'materiel' || (tab === 'feuille' && !estMagOuv)) &&
        (() => {
          const ch = chantiers.find((c) => c.id === chId);
          // Ce que le chantier a reçu du dépôt, retours déduits : on ne
          // rapporte que cela.
          const recu = {};
          (ch?.materiaux || [])
            .filter((m) => m.source !== 'fournisseur')
            .forEach((m) => {
              recu[m.ref] = (recu[m.ref] || 0) + (+m.qte || 0);
            });
          const disponibles = matRetour
            ? (stock || []).filter((a) => (recu[a.ref] || 0) > 0)
            : stock || [];
          const mcats = Array.from(new Set(disponibles.map((m) => m.cat || 'Divers')));
          const liste = disponibles.filter((a) => !matCat || (a.cat || 'Divers') === matCat);
          const cl = Object.keys(matCart).filter((k) => matCart[k] > 0);
          const setQ = (id, q) =>
            setMatCart((pp) => {
              const n = { ...pp };
              if (q <= 0) delete n[id];
              else n[id] = q;
              return n;
            });
          return (
            <Card>
              <Bar
                icon="📦"
                title="Matériel du dépôt"
                color={C.teal}
                sub="Quel matériel, à quelle heure, pour quel chantier"
              />
              <div style={{ padding: 13 }}>
                {/* Au dépôt, le magasinier sert un collègue : la sortie est à ce
                    collègue, au chantier choisi. */}
                <Tabs
                  items={[
                    ['ouvrier', '👷 Pour moi'],
                    ['magasinier', '🏭 Pour un collègue'],
                  ]}
                  active={fMode}
                  onChange={setFMode}
                />
                {fMode === 'magasinier' && (
                  <div style={{ marginBottom: 8 }}>
                    <div style={lblF}>Employé servi</div>
                    <select
                      value={fOuvrier}
                      onChange={(e) => setFOuvrier(e.target.value)}
                      style={selF}
                    >
                      <option value="">— choisir —</option>
                      {equipiers
                        .filter((e) => e.id !== emp.id)
                        .map((e) => (
                          <option key={e.id} value={String(e.id)}>
                            {nomComplet(e)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
                <Inp label="Chantier">
                  <select
                    value={chId}
                    onChange={(e) => setChId(chantierChoisi(chantiers, e.target.value))}
                    style={{
                      width: '100%',
                      border: '1px solid ' + C.border,
                      borderRadius: 9,
                      padding: '10px',
                      fontSize: 11,
                    }}
                  >
                    {chantiers
                      .filter((c) => c.statut === 'En cours')
                      .map((c) => (
                        <option key={c.id} value={c.id}>
                          {nomDuChantier(c, chantiers)}
                        </option>
                      ))}
                  </select>
                </Inp>
                <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                  {[
                    [false, '📤 Prendre au dépôt'],
                    [true, '↩️ Rapporter au dépôt'],
                  ].map(([retour, lb]) => (
                    <button
                      key={lb}
                      type="button"
                      aria-pressed={matRetour === retour}
                      onClick={() => {
                        setMatRetour(retour);
                        setMatCart({});
                        setMatCat('');
                      }}
                      style={{
                        flex: 1,
                        padding: '9px 6px',
                        borderRadius: 9,
                        fontSize: 11,
                        fontWeight: 800,
                        cursor: 'pointer',
                        border: '1.5px solid ' + (matRetour === retour ? C.teal : C.border),
                        background: matRetour === retour ? C.teal : C.white,
                        color: matRetour === retour ? '#fff' : C.ink,
                      }}
                    >
                      {lb}
                    </button>
                  ))}
                </div>
                {matRetour && liste.length === 0 ? (
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 10, lineHeight: 1.5 }}>
                    Ce chantier n&apos;a encore rien reçu du dépôt : rien à rapporter.
                  </div>
                ) : null}
                <div
                  style={{
                    display: 'flex',
                    gap: 7,
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    paddingBottom: 6,
                    marginBottom: 9,
                  }}
                >
                  <div
                    onClick={() => setMatCat('')}
                    style={{
                      flex: '0 0 auto',
                      whiteSpace: 'nowrap',
                      padding: '8px 13px',
                      borderRadius: 999,
                      fontSize: 10,
                      fontWeight: 700,
                      cursor: 'pointer',
                      border: '1px solid ' + (matCat === '' ? C.navy : C.border),
                      background: matCat === '' ? C.navy : C.white,
                      color: matCat === '' ? '#fff' : C.grey,
                    }}
                  >
                    Toutes
                  </div>
                  {mcats.map((cat) => (
                    <div
                      key={cat}
                      onClick={() => setMatCat(cat)}
                      style={{
                        flex: '0 0 auto',
                        whiteSpace: 'nowrap',
                        padding: '8px 13px',
                        borderRadius: 999,
                        fontSize: 10,
                        fontWeight: 700,
                        cursor: 'pointer',
                        border: '1px solid ' + (matCat === cat ? C.navy : C.border),
                        background: matCat === cat ? C.navy : C.white,
                        color: matCat === cat ? '#fff' : C.grey,
                      }}
                    >
                      {cat}
                    </div>
                  ))}
                </div>
                {liste.map((a) => {
                  const q = matCart[a.id] || 0;
                  return (
                    <div
                      key={a.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 9,
                        padding: '10px 0',
                        borderBottom: '1px solid ' + C.border,
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 10.5, fontWeight: 700 }}>{a.nom}</div>
                        <div style={{ fontSize: 8.5, color: C.muted }}>
                          {trf('{0} {1} au dépôt', +a.stock || 0, a.u || '')}
                          {a.cat ? ' · ' + a.cat : ''}
                        </div>
                      </div>
                      {q > 0 ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <button
                            onClick={() => setQ(a.id, q - 1)}
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: 8,
                              border: '1px solid ' + C.border,
                              background: C.white,
                              fontSize: 14,
                              cursor: 'pointer',
                            }}
                          >
                            −
                          </button>
                          <span
                            style={{
                              minWidth: 20,
                              textAlign: 'center',
                              fontSize: 12,
                              fontWeight: 800,
                            }}
                          >
                            {q}
                          </span>
                          <button
                            onClick={() => setQ(a.id, q + 1)}
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: 8,
                              border: 'none',
                              background: C.navy,
                              color: '#fff',
                              fontSize: 14,
                              cursor: 'pointer',
                            }}
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => setQ(a.id, 1)}
                          style={{
                            padding: '8px 12px',
                            borderRadius: 8,
                            border: 'none',
                            background: C.navy,
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 700,
                            cursor: 'pointer',
                          }}
                        >
                          ＋ Ajouter
                        </button>
                      )}
                    </div>
                  );
                })}
                {liste.length === 0 && !matRetour && (stock || []).length === 0 ? (
                  // Le dépôt vide : rien à prendre tant que le stock n'a pas
                  // d'articles. Le patron va les ajouter d'un geste.
                  <div
                    data-testid="depot-vide"
                    style={{
                      textAlign: 'center',
                      padding: 16,
                      color: C.grey,
                      fontSize: 11,
                      lineHeight: 1.5,
                    }}
                  >
                    Le dépôt n&apos;a encore aucun article. Les articles du dépôt se créent dans
                    Stock (côté Bâtiment) : ils apparaissent ensuite ici.
                    {modeTerrain && onNav ? (
                      <div style={{ marginTop: 10 }}>
                        <Btn
                          label="📦 Ajouter des articles au stock"
                          color={C.teal}
                          sm
                          onClick={() => onNav('stock')}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : liste.length === 0 && !matRetour ? (
                  <div style={{ textAlign: 'center', padding: 16, color: C.muted, fontSize: 10 }}>
                    Aucun article dans cette catégorie.
                  </div>
                ) : null}
                {cl.length > 0 && (
                  <div
                    style={{
                      marginTop: 12,
                      background: C.navy,
                      borderRadius: 12,
                      padding: '12px 14px',
                    }}
                  >
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,.7)', marginBottom: 8 }}>
                      {trf(
                        matRetour
                          ? '{0} article(s) rapporté(s) de {1} — heure notée : {2}'
                          : '{0} article(s) pris pour {1} — heure notée : {2}',
                        cl.reduce((x, k) => x + matCart[k], 0),
                        ch ? ch.nom : tr('le chantier'),
                        String(new Date().getHours()).padStart(2, '0') +
                          ':' +
                          String(new Date().getMinutes()).padStart(2, '0'),
                      )}
                    </div>
                    <Btn
                      label={
                        matEnvoi
                          ? '⏳ Enregistrement…'
                          : matRetour
                            ? '↩️ Rapporter au dépôt (retour en stock)'
                            : '📤 Sortir le matériel du stock (chantier)'
                      }
                      color={C.green}
                      full
                      disabled={matEnvoi || !ch}
                      onClick={async () => {
                        if (!ch || matEnvoi) return;
                        const servi =
                          fMode === 'magasinier'
                            ? equipiers.find((e) => String(e.id) === String(fOuvrier))
                            : null;
                        if (fMode === 'magasinier' && !servi) {
                          setFlash('Choisis l’employé servi.');
                          return;
                        }
                        // Une seule opération sur le serveur : le stock baisse
                        // (ou remonte) et le chantier porte le matériel au prix
                        // d'achat, avec l'employé, le jour et l'heure — ou rien
                        // ne bouge.
                        setMatEnvoi(true);
                        try {
                          await chantiersApi.depot(ch.id, {
                            retour: matRetour,
                            employeId: servi ? servi.id : undefined,
                            lignes: cl.map((k) => ({ articleId: Number(k), quantite: matCart[k] })),
                          });
                          setMatCart({});
                          setFlash(
                            matRetour
                              ? trf('✓ Matériel rapporté au dépôt depuis {0}', ch.nom)
                              : trf('✓ Matériel sorti du stock et associé à {0}', ch.nom),
                          );
                          await Promise.all([rechargeStock?.(), rechargeChantiers?.()]);
                        } catch (e) {
                          setFlash('⚠️ ' + (e?.message || tr("L'enregistrement a échoué.")));
                        } finally {
                          setMatEnvoi(false);
                        }
                      }}
                    />
                    <div
                      style={{
                        fontSize: 8,
                        color: 'rgba(255,255,255,.55)',
                        marginTop: 7,
                        lineHeight: 1.5,
                      }}
                    >
                      L&apos;heure est notée toute seule, au moment où tu valides. Le stock diminue
                      tout de suite et la sortie est enregistrée : qui, quel chantier, quel article,
                      combien, le jour et l&apos;heure.
                    </div>
                    <div
                      style={{
                        borderTop: '1px solid rgba(255,255,255,.15)',
                        marginTop: 12,
                        paddingTop: 12,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 9,
                          color: 'rgba(255,255,255,.75)',
                          marginBottom: 8,
                          lineHeight: 1.5,
                        }}
                      >
                        OU si ce matériel a été <b>acheté directement chez un fournisseur</b> (il
                        n'était pas dans le dépôt) :
                      </div>
                      <div
                        style={{ background: C.white, borderRadius: 10, padding: '8px 10px 2px' }}
                      >
                        <Inp
                          label="Fournisseur"
                          value={achatFourn}
                          onChange={(e) => setAchatFourn(e.target.value)}
                          placeholder="Ex. Hornbach Etoy"
                        />
                        <Inp
                          label={'Montant du bon (' + DEVISE + ')'}
                          type="number"
                          value={achatMontant}
                          onChange={(e) => {
                            setAchatMontant(e.target.value);
                            // Un montant corrigé à la main : la TVA lue ne lui correspond plus.
                            setAchatTva(null);
                          }}
                          placeholder="0.00"
                        />
                        {achatLecture && (
                          <div style={{ fontSize: 10, color: C.grey, margin: '-4px 0 8px' }}>
                            {achatLecture}
                          </div>
                        )}
                        {achatBon ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              marginBottom: 10,
                            }}
                          >
                            {String(achatBon.pieceMime).includes('pdf') ? (
                              <div style={{ fontSize: 26 }}>📄</div>
                            ) : (
                              <img
                                src={achatBon.piece}
                                alt="Photo du bon"
                                style={{
                                  width: 44,
                                  height: 44,
                                  objectFit: 'cover',
                                  borderRadius: 8,
                                  border: '1px solid ' + C.border,
                                }}
                              />
                            )}
                            <div style={{ flex: 1, fontSize: 9.5, fontWeight: 700, color: C.ink }}>
                              {String(achatBon.pieceMime).includes('pdf')
                                ? tr('📄 Facture jointe')
                                : '📸 Photo du bon jointe'}
                            </div>
                            <Btn
                              label="Retirer"
                              sm
                              ghost
                              color={C.grey}
                              onClick={() => {
                                setAchatBon(null);
                                setAchatTva(null);
                                setAchatLecture('');
                              }}
                            />
                          </div>
                        ) : (
                          <div style={{ marginBottom: 10 }}>
                            <PhotoBtn
                              label="📸 Photo du bon"
                              color={C.navy}
                              full
                              onPhoto={(_apercu, fichier) => joinsLeBon(fichier)}
                            />
                            {/* La facture reçue en PDF du fournisseur se joint aussi. */}
                            <label
                              style={{
                                display: 'block',
                                marginTop: 6,
                                border: '1.5px dashed ' + C.navy,
                                color: C.navy,
                                borderRadius: 10,
                                padding: '9px',
                                fontSize: 11.5,
                                fontWeight: 800,
                                textAlign: 'center',
                                cursor: 'pointer',
                              }}
                            >
                              {tr('📎 Joindre un fichier (PDF ou photo)')}
                              <input
                                type="file"
                                accept="application/pdf,image/*"
                                style={{ display: 'none' }}
                                onChange={async (e) => {
                                  const fichier = e.target.files && e.target.files[0];
                                  e.target.value = '';
                                  if (!fichier) return;
                                  await joinsLeBon(fichier);
                                }}
                              />
                            </label>
                          </div>
                        )}
                      </div>
                      <div style={{ marginTop: 8 }}>
                        <Btn
                          label={
                            achatEnvoi
                              ? 'Enregistrement…'
                              : '🏭 Acheté chez fournisseur → chantier (sans toucher le stock)'
                          }
                          color={C.amber}
                          full
                          disabled={achatEnvoi}
                          onClick={async () => {
                            if (achatEnvoi) return;
                            if (!ch) {
                              setAchatErr('Choisis d’abord le chantier.');
                              return;
                            }
                            const nowHM = () => {
                              const h = new Date();
                              return (
                                String(h.getHours()).padStart(2, '0') +
                                ':' +
                                String(h.getMinutes()).padStart(2, '0')
                              );
                            };
                            const heure = nowHM();
                            const items = cl
                              .map((k) => {
                                const a = (stock || []).find((m) => String(m.id) === String(k));
                                return a ? { a, q: matCart[k] } : null;
                              })
                              .filter(Boolean);
                            const montant = Math.round((+achatMontant || 0) * 100) / 100;
                            const fournisseur = achatFourn.trim();
                            // La depense part d'abord : si elle echoue, rien
                            // n'est impute au chantier, et l'ouvrier reessaie
                            // sans doubler la ligne de materiau.
                            const avecDepense = montant > 0 || !!achatBon;
                            setAchatErr('');
                            if (avecDepense) {
                              const libelle =
                                items
                                  .map(({ a, q }) => q + ' ' + (a.u || '') + ' ' + a.nom)
                                  .join(', ') || 'Achat fournisseur';
                              setAchatEnvoi(true);
                              try {
                                if (titulaire) {
                                  await monEspaceApi.achatFournisseur({
                                    chantierId: ch.id,
                                    fournisseur: fournisseur || null,
                                    montant,
                                    libelle,
                                    justificatif: achatBon?.piece || null,
                                    justificatifNom: achatBon?.pieceNom || null,
                                    tauxTva: achatTva?.tauxTva ?? null,
                                    montantTva: achatTva?.montantTva ?? null,
                                  });
                                } else {
                                  // Le bureau, qui consulte l'espace d'un
                                  // employe, tient les depenses de la societe.
                                  await depensesApi.cree({
                                    libelle: libelle + ' — ' + ch.nom + ' (' + emp.nom + ')',
                                    dateDepense: todayISO,
                                    montant,
                                    // La clé du plan comptable (compte 4000, TVA normale), pas le libellé.
                                    categorie: 'materiel',
                                    fournisseur: fournisseur || null,
                                    siteId: typeof ch.id === 'number' ? ch.id : null,
                                    justificatif: achatBon?.piece || null,
                                    justificatifNom: achatBon?.pieceNom || null,
                                    tauxTva: achatTva?.tauxTva ?? null,
                                    montantTva: achatTva?.montantTva ?? null,
                                  });
                                }
                              } catch (e) {
                                setAchatErr(
                                  e?.message ||
                                    'La dépense n’a pas pu être enregistrée. Rien n’a été imputé ; réessaie.',
                                );
                                setAchatEnvoi(false);
                                return;
                              }
                              setAchatEnvoi(false);
                            }
                            /* FLUX 2 : PAS de décrément du stock du dépôt. Le coût est
                               ajouté au chantier, et la ligne de matériau porte la trace :
                               provenance fournisseur, employé, date et heure. */
                            setChantiers &&
                              setChantiers((pp) =>
                                pp.map((c) =>
                                  c.id === ch.id
                                    ? {
                                        ...c,
                                        materiaux: [
                                          ...(c.materiaux || []),
                                          ...items.map(({ a, q }) => ({
                                            id: uid(),
                                            ref: a.ref,
                                            nom: a.nom,
                                            qte: q,
                                            u: a.u,
                                            pa: +a.pa || 0,
                                            date: today(),
                                            heure,
                                            empNom: emp.nom,
                                            source: 'fournisseur',
                                          })),
                                        ],
                                      }
                                    : c,
                                ),
                              );
                            setMatCart({});
                            setAchatFourn('');
                            setAchatMontant('');
                            setAchatBon(null);
                            setAchatTva(null);
                            setAchatLecture('');
                            setFlash(
                              '✓ Achat fournisseur enregistré pour ' +
                                ch.nom +
                                (avecDepense ? ' — dépense créée en comptabilité' : '') +
                                " — le stock du dépôt N'A PAS changé",
                            );
                          }}
                        />
                      </div>
                      {achatErr && (
                        <div
                          role="alert"
                          style={{
                            fontSize: 9.5,
                            color: '#FFD6D6',
                            marginTop: 6,
                            fontWeight: 700,
                          }}
                        >
                          {achatErr}
                        </div>
                      )}
                      <div
                        style={{
                          fontSize: 8,
                          color: 'rgba(255,255,255,.55)',
                          marginTop: 6,
                          lineHeight: 1.5,
                        }}
                      >
                        Le stock du dépôt <b>ne change pas</b> (le matériel n'y était pas). Le coût
                        est ajouté à la rentabilité du chantier et l'achat est tracé (fournisseur,
                        employé, date). Avec un montant ou la photo du bon, une dépense est créée en
                        comptabilité, sur ce chantier, la photo pour justificatif.
                      </div>
                    </div>
                  </div>
                )}
                {/* Ce qui est sorti pour ce chantier : qui, quel jour, à quelle
                    heure, combien de quoi — le relevé précis du matériel. */}
                {(ch?.materiaux || []).length > 0 && (
                  <div data-testid="sorties-chantier" style={{ marginTop: 14 }}>
                    <div style={{ ...lblF, marginBottom: 6 }}>
                      {trf('Matériel sorti pour : {0}', ch.nom)}
                    </div>
                    {(ch.materiaux || [])
                      .slice(-12)
                      .reverse()
                      .map((m, i) => (
                        <div
                          key={m.id || i}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 8,
                            padding: '7px 0',
                            borderBottom: '1px solid ' + C.border,
                            fontSize: 10,
                          }}
                        >
                          <span style={{ minWidth: 0 }}>
                            <b>
                              {m.qte} × {m.nom || m.d}
                            </b>
                            {m.source === 'fournisseur' ? ' · 🏭' : ''}
                            {/* Le reste d'un achat chez le fournisseur revient au dépôt. */}
                            <RetourAchatDepot
                              chantierId={ch.id}
                              achat={m}
                              lignes={ch.materiaux}
                              onFait={() => {
                                setFlash(trf('✓ Matériel rapporté au dépôt depuis {0}', ch.nom));
                                Promise.all([rechargeStock?.(), rechargeChantiers?.()]).catch(
                                  () => {},
                                );
                              }}
                            />
                          </span>
                          <span style={{ color: C.muted, flexShrink: 0, textAlign: 'right' }}>
                            {[m.date, m.heure, m.empNom].filter(Boolean).join(' · ')}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </Card>
          );
        })()}
      {tab === 'plans' && (
        <Card>
          <Bar
            icon="📐"
            title="Plans & croquis du chantier"
            color={C.navy}
            sub="Transmis par le bureau — lecture seule"
          />
          <div style={{ padding: 13 }}>
            <Inp label="Chantier">
              <select
                value={chId}
                onChange={(e) => setChId(chantierChoisi(chantiers, e.target.value))}
                style={{
                  width: '100%',
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '10px',
                  fontSize: 11,
                }}
              >
                {chantiers
                  .filter((c) => c.statut === 'En cours')
                  .map((c) => (
                    <option key={c.id} value={c.id}>
                      {nomDuChantier(c, chantiers)}
                    </option>
                  ))}
              </select>
            </Inp>
            {(() => {
              const ch = chantiers.find((c) => c.id === chId);
              // Tous les plans du chantier : « Envoyer au client » est un e-mail
              // au client, il ne décide pas de ce que l'équipe voit sur place.
              const pls = ch?.plans || [];
              if (!pls.length)
                return (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: 24,
                      color: C.muted,
                      fontSize: 9.5,
                      lineHeight: 1.5,
                    }}
                  >
                    Aucun plan pour ce chantier. Le bureau les ajoute dans Chantiers → Plans.
                  </div>
                );
              return pls.map((pl) => (
                <Card key={pl.id} style={{ marginBottom: 8 }}>
                  <div
                    style={{
                      padding: '11px 13px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <span style={{ fontSize: 20 }}>{pl.emoji || '📄'}</span>
                      <div>
                        <div style={{ fontSize: 10, fontWeight: 700 }}>{pl.nom}</div>
                        <div style={{ fontSize: 8, color: C.muted }}>
                          v{pl.version} · {pl.date}
                        </div>
                      </div>
                    </div>
                    {pl.src ? (
                      <a
                        href={pl.src}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        <div
                          style={{
                            background: C.navy,
                            color: '#fff',
                            borderRadius: 8,
                            padding: '7px 12px',
                            fontSize: 9.5,
                            fontWeight: 700,
                          }}
                        >
                          👁 Voir
                        </div>
                      </a>
                    ) : (
                      <span style={{ fontSize: 8.5, color: C.green, fontWeight: 700 }}>✓ Reçu</span>
                    )}
                  </div>
                </Card>
              ));
            })()}
          </div>
        </Card>
      )}
    </Shell>
  );
}

/** « 25.10.2026 » ou « 2026-10-25 » → « 2026-10-25 », pour trier les jours. */
function cleJour(d) {
  const t = String(d || '');
  const m = t.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
  return m ? m[3] + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0') : t;
}
